(function (factory) {
  // I'm a pre function
  factory();
} (function () {
    // I'm a factory getting executed
}));

angular.module('SumTotalComponents',['SumTotalAccordionModule','SumTotalClaw','SumTotalDatePicker','SumTotalDropdown','SumTotalEllipsisModule','SumTotalNGEnterModule','SumTotalValidatedText','SumTotalHeaderbarModule','SumTotalLeftNav','SumTotalNotificationTile','SumTotalPersonalization','SumTotalSectionModule','SumTotalSidePanel','SumTotalSlideOutModule','SumTotalTabModule','SumTotalTimeline','SumTotalTooltipModule','SumTotalTypeahead','SumTotalWebpartModule','SumTotalWizard','ngTable','gridster','ngAnimate','mgcrea.ngStrap','multi-transclude','pascalprecht.translate','ui.tree','kcd']);
/* jshint strict:false  */

angular.module("SumTotalAccordionModule", [])
.directive('sumtaccordion', function () {
  return {
    templateUrl: 'accordion/accordion_view.html',
    controller: 'AccordionController',
    transclude: true,
    // link: function ($scope, $element, $attributes, controller) {
    link: function ($scope) {
      $scope.oneAtATime = true;
      $scope.groups = [];
      $scope.items = [];

      $scope.addItem = function () {
        var newItemNo = $scope.items.length + 1;
        $scope.items.push('Item ' + newItemNo);
      };
    }
  };
});

/* jshint strict:false  */
angular.module('SumTotalClaw', [])
  .directive('clawChart', ['$theme', function ($theme) {
    return {
      restrict: 'EA',
      replace: false,
      transclude: true,
      templateUrl: 'claw/claw_view.html',
      link: function (scope, element, attrs, ctrl, transclude) { //jshint ignore:line
        scope.activityActionBtnClick = function (action, activityId) {
          scope.$emit('actionEvents', { action: action, activityId : activityId });
        };
        scope.completedActivities = [];
        scope.tableDisplayContent = "";

        scope.theme = $theme.theme;
        scope.container = element.parent()[0].offsetWidth;
        scope.autoDraw = attrs.autoDraw == 'false' ? false : true;
        scope.clawVisible = scope.autoDraw;
        scope.canvas = element.find("#clawCanvas");
        scope.transclusion = attrs.transclusion == 'true' ? true : false;

        if (attrs.responsive == 'true')
          scope.chartWidth = element.parent()[0].offsetWidth - parseInt(element.parent().css('paddingLeft').replace('px', ''), 10) - parseInt(element.parent().css('paddingRight').replace('px', ''), 10);
        else
          scope.chartWidth = attrs.chartWidth;
         scope.canvas[0].style.cursor = 'pointer';
        var ctx = scope.canvas[0].getContext("2d");
        scope.elements = [];
        scope.arcs = [];
        scope.capabilities = [];
        scope.selectedGap;
		scope.categoryName;
        scope.selectedCapability;
        scope.cX = parseInt(attrs.clawWidth); //jshint ignore:line
        scope.canvas[0].width = scope.chartWidth - 45;
        scope.canvas[0].height = scope.cX + 8;
        var qtrC = 0.5 * Math.PI;
        var toolTip = element.find("#clawtip");
        var tipCtx = toolTip[0].getContext("2d");
        var curPerc = 0.5 * Math.PI;
        scope.radius = 0.3714 * Math.min(scope.cX, scope.cX);
        scope.inc = 30;
        scope.competencyWidth = parseInt(attrs.competencyWidth); //jshint ignore:line
        scope.gapRoom = scope.canvas[0].width - scope.cX - scope.competencyWidth;
        scope.labelStyle = scope.gapRoom - 10;
        scope.gapRoomPercent = (scope.gapRoom / scope.canvas[0].width) * 100;
        scope.legendWidth = element.find(".legendContainer").width();

        scope.ie_ver = function () {
          var iev = 0;
          var ieold = (/MSIE (\d+\.\d+);/.test(navigator.userAgent));
          var trident = !!navigator.userAgent.match(/Trident\/7.0/);
          var rv = navigator.userAgent.indexOf("rv:11.0");

          if (ieold) iev = new Number(RegExp.$1);
          if (navigator.appVersion.indexOf("MSIE 10") != -1) iev = 10;
          if (trident && rv != -1) iev = 11;

          scope.iev = iev;
        };

        scope.ie_ver();

        scope.canvasClick = function (e) {
		scope.tableDisplayContent= "";
		scope.completedActivities = [];
		scope.$apply(attrs.arcClick)
          var mouse = scope.getMousePos(scope.canvas, e);
          var x = mouse.x;
          var y = mouse.y;
          if (x > (scope.cX + scope.competencyWidth)) {
            scope.elements.forEach(function (element) {
              if (y > element.y && y < element.y + element.height && x > element.x && x < element.x + element.width && (scope.categoryName = element.name,scope.tableDisplayContent = "Gaps", scope.selectedGap = element.data,scope.selectedGap.categoryName = element.name, scope.$apply())) {
				scope.selectedGap = element.data;
				scope.selectedGap.categoryName = element.name;
                scope.$apply();
              }
            });
          } else if (x > scope.cX) {
            scope.capabilities.forEach(function (capability) {
              if (y > capability.y && y < capability.y + capability.height && x > capability.x && x < capability.x + capability.width && (scope.tableDisplayContent = "Headers", scope.selectedCapability = capability.data, scope.$apply())) {
                scope.selectedCapability = capability.data;
                scope.$apply();
              }
            });
          } else if (x < scope.cX) {
            scope.arcs.forEach(function (arc) {
              scope.defineArc(arc);
              if (scope.iev == 11) {
                if (ctx.isPointInPath(x, y) && attrs && (scope.tableDisplayContent = arc.data.categoryKey, scope.completedActivities = arc.data.completedActivities, scope.$apply(attrs.arcClick))) {
                  scope.$apply(attrs.arcClick);
                }
              } else {
              if (ctx.isPointInStroke(x, y) && attrs && (scope.tableDisplayContent = arc.data.categoryKey, scope.completedActivities = arc.data.completedActivities, scope.$apply(attrs.arcClick))) {
                scope.$apply(attrs.arcClick);
              }
              }
            });
          }
        };

        scope.getColor = function (color) {
          if (color == 'success')
            return scope.theme.configuration["@brand-success"];
          else if (color == 'warning')
            return scope.theme.configuration["@brand-warning"];
          else if (color == 'danger')
            return scope.theme.configuration["@brand-danger"];
          else if (color == 'info')
            return scope.theme.configuration["@brand-info"];
          else
            return color;
        };

        scope.clawBtnClick = function () {

        };

        scope.completedActivities = [{
          "name": "test",
          "acquiredProficiency": 30,
          "requiredProficiency": 23
        },
    {
      "name": "test",
      "acquiredProficiency": 30,
      "requiredProficiency": 23
    }];

        scope.getMousePos = function (canvas, evt) {
          var rect = scope.canvas[0].getBoundingClientRect();
          return {
            x: evt.clientX - rect.left,
            y: evt.clientY - rect.top
          };
        };

        scope.canvasToolTip = function (e) {
          var hit = false;
          var mouse = scope.getMousePos(scope.canvas[0], e);
          var x = mouse.x;
          var y = mouse.y;
          var tipWidth, tipTxt;
          scope.elements.forEach(function (element) {
            if (y > element.y && y < element.y + element.height && x > element.x && x < element.x + element.width) {
              tipTxt = element.data.name;

              if (tipTxt.length > 80)
                tipTxt = tipTxt.substring(0, 77) + "...";

              tipWidth = tipCtx.measureText(tipTxt + " " + element.data.percent + "%").width + 10;

              if (x - (tipWidth / 2) < 0)
                toolTip[0].style.left = "10px";
              else if (x + (tipWidth / 2) > scope.canvas[0].width)
                toolTip[0].style.left = (scope.canvas[0].width - tipWidth) + "px";
              else
                toolTip[0].style.left = (x - (tipWidth / 2)) + "px";

              toolTip[0].style.top = (y - 17) + "px";
              toolTip[0].width = tipWidth;
              tipCtx.clearRect(0, 0, toolTip[0].width, toolTip[0].height);
              tipCtx.fillStyle = "#fff";
              tipCtx.font = "bold 12px Arial";
              tipCtx.fillText(tipTxt + " " + Math.round(element.data.percent * 10) / 10 + "%", 5, 15);
              hit = true;
            }
          });

          if (!hit)
            toolTip[0].style.left = "-3500px";
        };

        scope.canvas.click(scope.canvasClick);
        scope.canvas.mousemove(scope.canvasToolTip);

        scope.drawArc = function () {
          if (scope.data) {
            var radi = [], arcLength, textLength, txtAngle, labelTxt;
            for (var i = scope.data.length - 1; i >= 0; i--) {
              if (scope.data[i].percent > 100)
                scope.data[i].percent = 100;
              radi.push(scope.data[i].percent);
              arcLength = 2 * Math.PI * (scope.radius + (30 * i)) * (scope.data[i].percent / 360);
              textLength = ctx.measureText(scope.data[i].percent + "%");
              scope.arcRadians = scope.data[i].percent / 100 * qtrC + (qtrC);
              ctx.save();
              ctx.beginPath();
              ctx.lineWidth = 25;
              if (scope.data[i].color.indexOf('#') !== -1)
                ctx.strokeStyle = scope.data[i].color;
              else if (scope.data[i].color == 'success')
                ctx.strokeStyle = scope.theme.configuration["@brand-success"];
              else if (scope.data[i].color == 'warning')
                ctx.strokeStyle = scope.theme.configuration["@brand-warning"];
              else if (scope.data[i].color == 'danger')
                ctx.strokeStyle = scope.theme.configuration["@brand-danger"];
              else if (scope.data[i].color == 'info')
                ctx.strokeStyle = scope.theme.configuration["@brand-info"];
              ctx.arc(scope.cX, 1, scope.radius + (30 * i), 0.5 * Math.PI, scope.arcRadians, false);
              ctx.stroke();
              ctx.beginPath();
              ctx.arc(scope.cX, 1, scope.radius + (30 * i), scope.arcRadians, 1 * Math.PI, false);
              ctx.strokeStyle = "#eeeeee";
              ctx.stroke();

              ctx.save();
              if (textLength.width > arcLength) {
                txtAngle = (scope.data[i].percent + 60) / 100;
                ctx.fillStyle = "#4e5252";
              } else {
                txtAngle = scope.data[i].percent / 100;
                ctx.fillStyle = "#fff";
              }
              ctx.font = "bold 12px Arial";
              ctx.translate(scope.cX, 0);
              ctx.rotate(45 * Math.PI / 180 * txtAngle);
              ctx.fillText(scope.data[i].percent + "%", -12, scope.radius + (i * scope.inc) + 4);
              ctx.restore();

              scope.arcObject = {
                data: scope.data[i],
                cx: scope.cX,
                cy: 1,
                radius: scope.radius + (30 * i),
                start: 0.5 * Math.PI,
                end: scope.arcRadians
              };
              scope.arcs.push(scope.arcObject);
            }
            scope.inverseMin = 100 - Math.min.apply(null, radi);
          }
        };

        scope.defineArc = function (arc) {
          ctx.beginPath();
          ctx.arc(arc.cx, arc.cy, arc.radius, arc.start, arc.end);
        };

        scope.buildHeaders = function () {
          if (scope.data) {
            for (var i = scope.data.length - 1; i >= 0; i--) {
              ctx.save();
              ctx.beginPath();
              ctx.fillStyle = "#eeeeee";
              ctx.rect(scope.cX + 1, scope.radius + (i * scope.inc) - 11, scope.competencyWidth, 25);
              ctx.fill();
              ctx.fillStyle = "#4e5252";
              ctx.textAlign = "start";
              ctx.font = "bold 12px Arial";
              ctx.fillText("of", scope.cX + 5, scope.radius + (i * scope.inc) + 7);
              ctx.font = "bold 14px Arial";
              ctx.fillText(scope.data[i].id, scope.cX + 20, scope.radius + (i * scope.inc) + 7);

              scope.capabilityObject = {
                data: scope.data[i],
                x: scope.cX + 1,
                y: scope.radius + (i * scope.inc) - 11,
                width: scope.competencyWidth,
                height: 25
              };
              scope.capabilities.push(scope.capabilityObject);
            }
          }
        };

        scope.buildGaps = function () {
          if (scope.data) {
            for (var i = scope.data.length - 1; i >= 0; i--) {
              scope.barStart = scope.cX + scope.competencyWidth + 2;
              scope.barWidth = 0;
              scope.localGapRoom = scope.gapRoom - scope.data[i].items.length - 1;
              var txtLabel, txtLength, txtPercentLength, txtValLength;

              for (var j = 0; j < scope.data[i].items.length; j++) {
                ctx.beginPath();
                ctx.font = "12px Arial";
                ctx.textAlign = "center";
                if (scope.data[i].items[j].percent > 0)
                  scope.gapCount = scope.gapCount + 1;
                txtLabel = scope.data[i].items[j].name + " " + Math.round(scope.data[i].items[j].percent) + "%";
                txtLength = ctx.measureText(scope.data[i].items[j].name + " " + Math.round(scope.data[i].items[j].percent) + "%").width + 5;
                txtPercentLength = ctx.measureText(Math.round(scope.data[i].items[j].percent) + "%").width;
                txtValLength = ctx.measureText(Math.round(scope.data[i].items[j].percent)).width;
                scope.barStart = scope.barStart + scope.barWidth + 1;
                scope.barWidth = (scope.data[i].items[j].percent / scope.inverseMin) * scope.localGapRoom;
                if (scope.data[i].items[j].color != undefined) {
                  if (scope.data[i].items[j].color.indexOf('#') !== -1)
                    ctx.fillStyle = scope.data[i].color;
                  else if (scope.data[i].items[j].color == 'success')
                    ctx.fillStyle = scope.theme.configuration["@brand-success"];
                  else if (scope.data[i].items[j].color == 'warning')
                    ctx.fillStyle = scope.theme.configuration["@brand-warning"];
                  else if (scope.data[i].items[j].color == 'danger')
                    ctx.fillStyle = scope.theme.configuration["@brand-danger"];
                  else if (scope.data[i].items[j].color == 'info')
                    ctx.fillStyle = scope.theme.configuration["@brand-info"];
                }
                ctx.rect(scope.barStart, scope.radius + (i * scope.inc) - 11, scope.barWidth, 25);
                ctx.fill();
                ctx.fillStyle = "#ffffff";

                if (txtValLength > scope.barWidth) {
                  ctx.fillText("", scope.barWidth * 0.5 + scope.barStart, scope.radius + (i * scope.inc) + 6);
                } else if (txtPercentLength > scope.barWidth) {
                  ctx.fillText(Math.round(scope.data[i].items[j].percent), scope.barWidth * 0.5 + scope.barStart, scope.radius + (i * scope.inc) + 6);
                } else if (txtLength > scope.barWidth) {
                  ctx.fillText(Math.round(scope.data[i].items[j].percent) + "%", scope.barWidth * 0.5 + scope.barStart, scope.radius + (i * scope.inc) + 6);
                } else {
                  ctx.fillText(txtLabel, scope.barWidth * 0.5 + scope.barStart, scope.radius + (i * scope.inc) + 6);
                }

                scope.gapObject = {
                  data: scope.data[i].items[j],
				  name: scope.data[i].categoryKey,
                  x: scope.barStart,
                  y: scope.radius + (i * scope.inc) - 11,
                  width: scope.barWidth,
                  height: 25
                };
                scope.elements.push(scope.gapObject);
              }
              ctx.closePath();
            }
          }
        };

        scope.drawClaw = function () {
		  scope.selectedGap = null;
          scope.selectedCapability = null;
          scope.completedActivities = null;
          scope.clawVisible = true;
          scope.gapCount = 0;
          // draw the background
          ctx.beginPath();
          ctx.save();
          ctx.translate(0.5, 0.5);
          scope.elements = [];
          scope.arcs = [];
          scope.capabilities = [];
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, scope.canvas[0].width, scope.canvas[0].height);
          ctx.strokeStyle = "#adadad";
          ctx.lineWidth = 1;
          ctx.moveTo(0, 0);
          ctx.lineTo(scope.canvas[0].width, 0);
          ctx.moveTo(0, scope.cX + 7);
          ctx.lineTo(scope.canvas[0].width, scope.cX + 7);
          ctx.moveTo(scope.cX + 0, 0);
          ctx.lineTo(scope.cX + 0, scope.cX + 7);
          ctx.moveTo(scope.cX + 2 + scope.competencyWidth, 0);
          ctx.lineTo(scope.cX + 2 + scope.competencyWidth, scope.cX + 7);
          ctx.moveTo(scope.cX, 0);
          ctx.lineTo(0, scope.cX);
          ctx.moveTo(scope.cX, 0);
          ctx.lineTo(0, scope.cX / 2);
          ctx.moveTo(scope.cX, 0);
          ctx.lineTo(scope.cX / 2, scope.cX);
          ctx.stroke();

          //build claw
          scope.buildHeaders();
          scope.drawArc();
          scope.buildGaps();
          ctx.restore();
        };

        $(window).resize(function () {
          if (scope.clawVisible) {
            scope.$apply(function () {
              scope.resize();
            });
          }
        });

        scope.resize = function () {
          if (!scope.clawVisible)
            scope.drawClaw();
          curPerc = 0.5 * Math.PI;
          if (attrs.responsive == 'true')
            scope.chartWidth = element.parent()[0].offsetWidth - 35;
          else
            scope.chartWidth = attrs.chartWidth;
          scope.canvas[0].width = scope.chartWidth - 45;
          scope.gapRoom = scope.canvas[0].width - scope.cX - scope.competencyWidth;
          scope.labelStyle = scope.gapRoom - 10;
          scope.gapRoomPercent = (scope.gapRoom / scope.canvas[0].width) * 100;
          scope.legendWidth = element.find(".legendContainer").width();
          scope.redraw();
        }

        scope.redraw = function () {
          ctx.clearRect(0, 0, scope.canvas[0].width, scope.canvas[0].height);
          scope.drawClaw();
        };

        scope.$watch('data', function () {
          if (scope.autoDraw)
            scope.drawClaw();
        });

        scope.$watch('theme', function (newVal, oldVal) {
          if (scope.clawVisible)
            scope.resize();
        }, true);

        scope.$on('drawClaw', function () {
          scope.resize();
        });

        scope.$on('resizeClaw', function () {
          if (scope.clawVisible)
            scope.resize();
        });
      }
    };
  }]);

angular.module('SumTotalDatePicker', ['mgcrea.ngStrap'])
  .directive('sumtDatepicker', ['$timeout', '$datepicker', '$dateFormatter', '$dateParser', function ($timeout, $datepicker, $dateFormatter, $dateParser) {
    'use strict';

    var defaults = angular.extend({}, {
      dateFormat: 'shortDate',
      strictFormat: false,
      labelInput: null,
      id: null,
      placement: 'bottom-left',
      placeholder: null,
      container: 'body',
      labelNext: 'DATEPICKER_NEXT',
      labelPrevious: 'DATEPICKER_PREVIOUS',
      labelMonth: 'DATEPICKER_MONTHS',
      labelYear: 'DATEPICKER_YEARS',
      labelDays: 'DATEPICKER_DAYS',
      dateType: 'date',
      timezone: null,
      modelDateFormat: null
      },
      $datepicker.defaults);

    return {
      restrict: 'E',
      scope: {
        ngModelDate: '=ngModel',
        required: '=ngRequired',
        disabled: '=ngDisabled'
      },
      require: ['ngModel', '?ngRequired', '?ngDisabled'],
      templateUrl: 'datepicker/datepicker.html',
      link: {
        pre: function preLink(scope, element, attr, controllers) {
          var ngModelController = controllers[0];

          var options = {
            scope: scope,
            lang: $dateFormatter.getDefaultLocale()
          };

          angular.forEach([
              'dateFormat',
              'placement',
              'modelDateFormat',
              'strictFormat',
              'labelInput',
              'lang',
              'id',
              'placeholder',
              'container',
              'labelNext',
              'labelPrevious',
              'labelMonth',
              'labelYear',
              'labelDays',
              'timezone'
            ],
            function (key) {
              if (angular.isDefined(attr[key])) options[key] = attr[key];
            });

          options = angular.extend({}, defaults, options);

          var dateParser = $dateParser({
            format: options.dateFormat,
            lang: options.lang,
            strict: options.strictFormat
          });

          if (angular.isDefined(attr.id)) {
            scope.inputId = attr.id + '_input';
            scope.pickerId = attr.id + '_picker';
          } else if (attr.ngModel) {
            scope.inputId = attr.ngModel + '_input';
            scope.pickerId = attr.ngModel + '_picker';
          }

          scope.placement = options.placement;
          scope.dateFormat = options.dateFormat;
          scope.labelInput = attr.labelInput;
          scope.textboxPlaceholder = attr.placeholder;
          scope.container = attr.container || 'body';

          scope.labelNext = attr.labelNext || 'DATEPICKER_NEXT';
          scope.labelPrevious = attr.labelPrevious || 'DATEPICKER_PREVIOUS';
          scope.labelMonth = attr.labelMonth || 'DATEPICKER_MONTHS';
          scope.labelYear = attr.labelYear || 'DATEPICKER_YEARS';
          scope.labelDays = attr.labelDays || 'DATEPICKER_DAYS';

          scope.timezone = attr.timezone || options.timezone;

          var btn = element.find('button');
          angular.forEach(['placement', 'container', 'delay'], function (key) {
            if (angular.isDefined(key)) {
              btn.attr(key, attr[key]);
            }
          });

          // Observe attributes for changes
          angular.forEach(['minDate', 'maxDate'], function (key) {
            if (angular.isDefined(attr[key])) {
              attr.$observe(key, function (newValue) {
                scope[key] = dateParser.getDateForAttribute(key, newValue);
              });
            }
          });
        }
      }
    };
  }]);

/* jshint strict:false  */

angular.module("SumTotalDropdown", [])
  .controller('dropDownCtrl', ['$scope', function ($scope) {
    $scope.dropdown = [
      {
        "text": "<i class=\"fa fa-download\"></i>&nbsp;Another action",
        "href": "#anotherAction"
              },
      {
        "text": "<i class=\"fa fa-globe\"></i>&nbsp;Display an alert",
        "click": "$alert(\"Holy guacamole!\")"
              },
      {
        "text": "<i class=\"fa fa-external-link\"></i>&nbsp;External link",
        "href": "/auth/facebook",
        "target": "_self"
              },
      {
        "divider": true
              },
      {
        "text": "Separated link",
        "href": "#separatedLink"
              }
            ];
    }]);

/* jshint strict:false  */
angular.module("SumTotalEllipsisModule", [])
  .directive('timelineellipsis', function () {
    return {
      restrict: 'A',
      replace: false,
      template: '<div class="sumt-ellipsis-container" ng-model="currentValue" title="">{{currentValue}}<div ng-hide="ellipsisExpanded" class="sumt-ellipsis-characters">...</div></div><div class="sumt-expand-container" ng-show="useClickExpand()"><a ng-click="handleClickEvent()" class="sumt-expand-collapse">{{buttonText}}<i ng-class="iconClass"/></a></div>',
      link: function (scope, element, attrs) {
        scope.buttonText = attrs.expandText;
        scope.iconClass = attrs.expandIconClass;
        scope.showMore = false;
        scope.useClickExpand = function () {
          var retArgs = false;
          if (attrs.useClickExpand === "true" && scope.showMore) {
            retArgs = true;
          }
          return retArgs;
        };
        scope.originalText = '';
        scope.ellipsisText = '';
        scope.originalMaxHeight = '';
        scope.ellipsisExpanded = false;
        scope.containerElement = element.find('.sumt-ellipsis-container');
        //scope.buttonObj = element.find('.sumt-expand-collapse');
        scope.currentValue = '';
        scope.ellipsisElements = [];


        scope.handleClickEvent = function () {
          if (!scope.ellipsisExpanded) {
            //scope.currentValue = scope.originalText;
            scope.ellipsisExpanded = true;
            scope.originalMaxHeight = element.css("max-height");
            scope.containerElement.css("max-height", "none");
            scope.buttonText = attrs.collapseText;
            scope.iconClass = attrs.collapseIconClass;
            //element.find('.icon-downarrow-blue').addClass("icon-uparrow-blue");
            //element.find('.icon-downarrow-blue').removeClass("icon-downarrow-blue");
          } else if (scope.ellipsisExpanded) {
            //scope.currentValue = scope.ellipsisText;
            scope.ellipsisExpanded = false;
            scope.containerElement.css("max-height", "3.75em");
            scope.buttonText = attrs.expandText;
            scope.iconClass = attrs.expandIconClass;
            //element.find('.icon-uparrow-blue').addClass("icon-downarrow-blue");
            //element.find('.icon-uparrow-blue').removeClass("icon-uparrow-blue");
          }
        };

        if (!scope.ellipsisExpanded) {
          //if () {
          //if (scope.textCheck) {

          scope.currentValue = scope.$eval(attrs.descValue).expandableText;
          //scope.originalText = scope.$eval(attrs.descValue).expandableText;

          var tempElement = $(scope.containerElement).clone().insertBefore($(scope.containerElement));
          tempElement.css({
            position: "absolute",
            visibility: "hidden",
            zindex: "-1"
          });

          var width = parseInt(scope.containerElement[0].style.width ? scope.containerElement[0].style.width : (scope.containerElement.css("max-width") != "none" ? scope.containerElement.css("max-width") : scope.containerElement.css("width")), 10);
          var height = parseInt(scope.containerElement[0].style.height ? scope.containerElement[0].style.height : (scope.containerElement.css("max-height") != "none" ? scope.containerElement.css("max-height") : null), 10);
          var curText = scope.$eval(attrs.descValue).expandableText;

          tempElement.css({
            "width": height ? width + "px" : "",
            "max-width": "none",
            "height": "",
            "max-height": "none"
          });
          tempElement.text(curText);

          if ((height && tempElement.height() > height) || (!height && tempElement.width() > width)) {
            scope.showMore = true;
            //while (curText.length > 0 && ((height && tempElement.height() > height) || (!height && tempElement.width() > width))) {
            //	curText = curText.substring(0, curText.length - 1);
            //	tempElement.text(curText + "...");
            //	//console.log('got here - ' + test++);
            //}
            //scope.ellipsisText = tempElement.text();
            //scope.currentValue = tempElement.text();
          }
          tempElement.remove();
          //}
          //}
        }
        if (attrs.useAutoResize) {
          if (scope.ellipsisElements.length === 0) {
            $("#divMainContent").on("content-resize", function () {
              if ($SumtUI.EllipsisResizeTimeout)
                window.clearTimeout($SumtUI.EllipsisResizeTimeout);
              $SumtUI.EllipsisResizeTimeout = window.setTimeout(function () {
                for (var i = 0; i < $SumtUI.EllipsisElements.length; i++)
                  scope.applyEllipsis($SumtUI.EllipsisElements[i]);
              }, 100);
            });
          }
          scope.ellipsisElements.push(scope.containerElement);
        }
      }
    };
  });

angular.module("SumTotalNGEnterModule", [])
.directive('ngEnter', function () { //a directive to 'enter key press' in elements with the "ng-enter" attribute
   return function (scope, element, attrs) {
     element.bind("keydown keypress", function (event) {
       if (event.which === 13) {
         scope.$apply(function () {
           scope.$eval(attrs.ngEnter);
         });

         event.preventDefault();
       }
     });
   };
});

/* jshint strict:false */
angular.module('SumTotalValidatedText', [])
  .directive('sumtValidatedText', function () {
    return {
      restrict: 'EA',
      //      require: ['ngModel', '^form'],
      //      require: '^form',
      replace: true,
      templateUrl: 'forms/text.html',
      scope: {
        validatedName: '@',
        validatedLabel: '&',
        controlData: '=',
        required: '@'
      },
      link: function (scope, element, attrs, controllers) {  // jshint ignore:line
        //scope._required = (scope.required === 'true') ? '' : 'required';
//        if (scope.required === 'true') {
//          element.find('input').attr('required', true);
//        }

        scope.getFormGroupClass = function (invalid, dirty, valid) {
          if (invalid && dirty) {
            return 'has-error';
          } else if (valid && dirty) {
            return 'has-success';
          } else {
            return '';
          }
        };
      }
    };
  });

/* jshint strict:false */
angular.module("SumTotalHeaderbarModule", [])
  .directive('headerbar', ['MultiTransclude', '$compile', function (MultiTransclude, $compile) {
  	return {
  		restrict: 'EA',
  		transclude: true,
  		replace: true,
  		scope: {
            containerElement: '=',
            pageTitleSelector: '@'
  		},
  		templateUrl: 'headerbar/headerbar_view.html',
  		link: function (scope, element, attrs) {

            scope.lastScrollTop = 0;
            scope.isScrollUp = false;
            scope.isIE = false;

            //check if this is on IE
            if(navigator.userAgent.indexOf("MSIE") != -1 || (!!document.documentMode))
              scope.isIE = true;

            //get the container on which scrolling is available
            var containerElement = scope.containerElement;

            $(containerElement).scroll(function () {

              var top = $(this).scrollTop();

              var header = $(containerElement).find('#divHeader');

              //when scrolling down, move the header to its negative height so it disappears
              if (top > scope.lastScrollTop && top > header.height()) {
                var delta = "-" + header.height().toString();
                //transform the header to slide up and hide
                header.attr('style', "transform: translate3d(0px, " + delta + "px, 0px);");
                scope.isScrollUp = false;
              }

                //scrolling up
              else {

                //let the header scroll out of view normally
                if (!scope.isScrollUp && top != 0 && top <= header.height())
                  return;

                //For IE, there is a known issue regarding jumpy scrolling, the scroll is not smooth. Also, this method gets called several times on Chrome n Firefox for one scroll,
                //but for IE, it gets called only once per scroll which makes the movement choppy. So for IE, let's always transform so it's consistent.
                if (scope.isIE) {
                  header.attr('style', "transform: translate3d(0px, " + top.toString() + "px, 0px);");
                }
                else {
                  //the first time we scroll up, transform the header so that it slides down. But if scrolling up continuously
                  //we don't want to transform everytime, just fix the header to the top so it stays there
                  if (scope.isScrollUp)
                    header.attr('style', "top: " + top.toString() + "px");

                  else
                    header.attr('style', "transform: translate3d(0px, " + top.toString() + "px, 0px);");
                }

                scope.isScrollUp = true;

                //get the title component if pageTitleSelector is provided
                var titleComponent = null;
                if (scope.pageTitleSelector != '' && scope.pageTitleSelector != undefined && scope.pageTitleSelector != null)
                  titleComponent = angular.element(scope.pageTitleSelector);

                if (titleComponent != null) {
                  //Typically on a slideout, there is a page title and some padding on the whole slideout. When we transform the header to
                  //show up, it leaves the space for title and padding-top as is. To remove that space, we will apply some styles here.
                  //When scrolling up (not all the way to the top) hide the title and remove the padding-top of the container.
                  //when we are scrolled to the top of the page, remove these styles. We need the title and padding to show up.

                  if (top > 0) {
                    titleComponent.attr('style', "display: none;");
                    containerElement.attr('style', "padding-top: 0");
                  }

                  else {
                    titleComponent.removeAttr('style');
                    containerElement.removeAttr('style');
                    //since we reached the top, the scroll up is complete
                    scope.isScrollUp = false;
                  }
                }
              }

              //keep track of scrolling
              scope.lastScrollTop = top;
           });
  		}
  	};
  }]);

angular.module("SumTotalLeftNav", ['ngSanitize'])
  .directive('leftNavigation', ['$leftNavs', function ($leftNavs) {
    return {
      replace: false,
      restrict: 'A',
      templateUrl: 'leftnav/leftnav_view.html',
      transclude: true,
      scope: {
        header: '=',
        navData: '=',
        selectedNavData: '=',
        nodeClicked: '=',
        imageclicked: "&",
        persondata: "=",
        emulation: "=",
        exitemulation: "&",
		switchdomain:"=",
		translationobject:"="
      },
      link: function (scope, element, attrs) {
        scope.leftNavsProvider = $leftNavs;

        var key = attrs.name || attrs.id;
        key = key || 'defaultLeftNav';

        var contentTemplateUrl = angular.isDefined(attrs['contentTemplateUrl']) ? attrs['contentTemplateUrl'] : 'leftnav/leftnav_content_template_view.html';

        scope.asideScope = scope.$new();
        scope.asideScope.title = scope.header;
        scope.asideScope.show = false;

        scope.asideOptions = {
          title: scope.asideScope.title,
          backdrop: false,
          scope: scope.asideScope,
          templateUrl: contentTemplateUrl,
          html: true,
          placement: 'left',
          animation: 'am-slide-left',
          keyboard: false,
          show: scope.asideScope.show
        };
        scope.leftNavsProvider.addLeftNavigation(key, scope.asideOptions);

        scope.leftNavigationObject = scope.leftNavsProvider.getLeftNavigation(key);

        scope.navigateToAdmin = function (node, item) {
          scope.nodeClicked(node);
        }

        scope.close = function () {
          scope.leftNavsProvider.close(key);
        };

        scope.$watch('header', function (newVal) {
          scope.asideScope.title = newVal
        });

        scope.handleNodes = function (node, item) {

          item.toggle();
        }

        scope.handleNodeSelected = function (node, item) {

          if (node.RPKey == "Catalog") {

            scope.nodeClicked(node)
          } else {
            if (scope.nodeClicked && typeof scope.nodeClicked === 'function' && node.childNodes == null || node.childNodes.length == 0) {
              scope.nodeClicked(node);
            } else {
              item.toggle();
            }
          }

        };
      }
    };
  }]);

angular.module('SumTotalLeftNav')
  .provider('$leftNavs', function () {
    var _navigationsHash = {};
    var _currentKey = null;
    var _previousKey = null;

    var _addNavigation = function (key, leftNavAside) {
      var scopedObject = {
        isShown: false,
        showLimit: 3,
        toggleLimit: false,
        appended: false,
        onClose: null,
        leftNavAside: leftNavAside
      };

      if (!_navigationsHash[key]) {
        _navigationsHash[key] = scopedObject;
      }
    };

    function _closeCurrent() {
      if (_currentKey) {
        _navigationsHash[_currentKey].leftNavAside.hide();
        _navigationsHash[_currentKey].isShown = false;
        _previousKey = _currentKey;
      }
    };

    function _toggleNavigation(key, state) {
      switch (state) {
      case "open":
        _closeCurrent();
        if (_navigationsHash[key]) {
          _navigationsHash[key].leftNavAside.show();
          _navigationsHash[key].isShown = true;
          _currentKey = key;
        }
        break;
      case "close":
        if (_navigationsHash[key]) {
          _navigationsHash[key].leftNavAside.hide();
          _navigationsHash[key].isShown = false;
          _currentKey = null;
          _previousKey = null;
        }
        break;
      }
    };

    this.$get = ['$log', '$aside', '$injector', function ($log, $aside, $injector) {
      var navigationsHash = _navigationsHash;

      return {
        /**
         * Gets a left navigation object by its key.
         * @param   {string} key Unique key identifying the left navigation.
         * @returns {object} Object representing the left navigation.
         */
        getLeftNavigation: function (key) {
          $log.debug('Getting left navigation:', key);

          return navigationsHash[key];
        },
        /**
         * Adds a left navigtaion object.
         * @param {string} key          Unique key for the left navigation
         * @param {object} asideOptions Options hash.
         */
        addLeftNavigation: function (key, asideOptions) {
          _addNavigation(key, $aside(asideOptions));
        },
        /**
         *
         * @param key
         * @param onClose
         */
        open: function (key, onClose, targetSource) {
          if (onClose) {
            _navigationsHash[key].onClose = onClose;
          }

          //          var $slideout = $injector.get('$slideout');
          //          if ($slideout) {
          //            $slideout.close();
          //          }
          _toggleNavigation(key, "open");
		  if(targetSource)
		  {
			  _navigationsHash[key].targetSource=targetSource;
		  }		
        },
        /**
         * Closes a specific slideout. If no key is provided it will close the current.
         * @param {string} key Key identifier for the slideout. If none is provided it will clsoe the current slideout. BEWARE!
         */
        close: function (key) {
          if (key && _navigationsHash && _navigationsHash[key]) {
            if (_navigationsHash[key].onClose) {
              var onCloseCallback = _navigationsHash[key].onClose;
              _navigationsHash[key].onClose = undefined;
              onCloseCallback();
            } else {
              _toggleNavigation(key, "close");
            }
          } else if (!key && _currentKey) {
            this.close(_currentKey);
          }
		  if(_navigationsHash[key].targetSource && _navigationsHash[key].targetSource.currentTarget)
		  {
		  setTimeout(function () {
               angular.element($(_navigationsHash[key].targetSource.currentTarget)).focus();
              });
		  }
        },
        toggle: function (key) {
          if (!_navigationsHash[key]) return;

          if (_navigationsHash[key].isShown) {
            _toggleNavigation(key, "close");
          } else {
            _toggleNavigation(key, "open");
          }
        },
        /**
         *
         */
        getPreviousKey: function () {
          return _previousKey;
        }
      };
    }];
  });

angular.module("SumTotalLeftNav")
  .directive("selfheader", function () {
    return {
      replace: true,
      restrict: 'A',
      templateUrl: 'leftnav/self_header.html',
      scope: {
        imageclicked: '&',
        persondata: '=',
        emulation: "=",
        exitemulation: "&"
      },
      link: function (t, a, i) {}
    }
  });

/* jshint strict:false  */
angular.module('SumTotalNotificationTile', [])
  .directive('notificationTile',['$interval', function ($interval) {
    return {
      restrict: 'EA',
      replace: false,
      transclude: true,
      templateUrl: 'notificationTile/notificationTile_view.html',
      scope: {
        data: '='
      },
      link: function (scope, element, attrs) { //jshint ignore:line
        scope.pagination = attrs.pagination !== undefined ? attrs.pagination : 'false';
        scope.notifications = [];
        scope.selected = false;
        scope.pages = 0;
        scope.currentPage = 1;
        scope.timer = attrs.isTimed !== undefined && attrs.isTimed !== null ? attrs.isTimed : 'false';
        var interval;

        scope.startTimer = function(){
          interval = $interval(scope.paginate, scope.delay);
        }

        scope.getPages = function(){
          return new Array(scope.pages);
        }

        scope.setPage = function(idx){
          scope.currentPage = idx;
        }

        scope.getClass = function(item){
          return item.type;
        };

        scope.paginate = function(){
          if(scope.currentPage >= scope.pages)
            scope.currentPage = 1;
          else
            scope.currentPage += 1;
        }

        this.addNotifSection = function (data) {
          scope.notifications.push(data);
          scope.pages++;
        };

        if (scope.data !== undefined) {
          angular.forEach(scope.data, function (item) {
            this.addNotifSection(item);
          });
        }

        if(scope.timer === 'true' || attrs.delay !== undefined){
          scope.delay = scope.$eval(attrs.delay) !== undefined && scope.$eval(attrs.delay) !== null ? attrs.delay: 5000;
          scope.startTimer();
        }

        element.on('$destroy', function() {
          $interval.cancel(interval);
        });
      }
    };
  }]);

angular.module('SumTotalPersonalization', [])
  .provider('$theme', function () {
    /**
     * themeTemplate - Template of a theme from the server DTO.
     * currentTheme - variable to store reference to the current theme.
     */
    var themeTemplate = this.themeTemplate = {
        "ThemeKey": "DEFAULT",
        "Name": "Default Theme",
        "ClientJSON": {
          "colors": [
          "#ef4c00",
//            "#000",
          "#007bc3",
          "#a419b7",
          "#76b800",
          "#ffae00"
        ],
          "axisColor": "#5b5b5b",
          "gridColor": "#5b5b5b",
          "textColor": "#5b5b5b",
          "borderColor": "#ffffff",
          "backgroundColor": "#ffffff",
          "labelColor": "#5b5b5b",
          "@brand-primary": "darken(#428bca, 6.5%)",
          "@brand-success": "#1fbba6",
          "@brand-info": "#227AB9",
          "@brand-warning": "#ffc600",
          "@brand-danger": "#f27c2a"
        },
        "PaletteJSON": {
          "primary": "#077bc1",
          "palette": [
          "#0078c1",
          "#74b712",
          "#fead11",
          "#a41cb5",
          "#ee4b04",
          "#5c666f",
          "#e0e0df",
          "#ffffff"
        ]
        }
      },
      currentTheme = {},
      rootScope = null;

    /**
     * Sets the current theme in the provider.
     * @param   {Object}   theme ThemeDTO JSON object.
     */
    var setCurrentTheme = this.setCurrentTheme = function (theme) {
      theme = theme || themeTemplate;

      var clonedTheme = angular.copy(theme);
      currentTheme.key = clonedTheme.ThemeKey;
      currentTheme.name = clonedTheme.Name;
      currentTheme.configuration = clonedTheme.ClientJSON
      currentTheme.palette = clonedTheme.PaletteJSON;

      /**
       * Safe method to get a theme color
       * @param   {String} propertyName Color's name
       * @param   {String} defaultValue If the property cannot be found default to this color.
       * @returns {String} Color string
       */
      currentTheme.configuration.getColor = function (propertyName, defaultValue) {
        if (currentTheme.configuration && currentTheme.configuration[propertyName]) {
          return currentTheme.configuration[propertyName];
        } else {
          return defaultValue;
        }
      };

      if (rootScope) {
        rootScope.$broadcast('themeUpdated', currentTheme);
      }

    };

    this.$get = ['$log', '$rootScope', function ($log, $rootScope) {
      rootScope = $rootScope;

      if (!currentTheme || !currentTheme.key) {
        $log.debug('Theme not configured in app.config. Configuring now.');
        setCurrentTheme(themeTemplate)
      }
      return {
        "theme": currentTheme,
        "curTheme": currentTheme,
        "setCurrentTheme": setCurrentTheme
      };
    }];
  });

/* jshint strict:false  */
angular.module("SumTotalSectionModule", [])
  // The accordion directive simply sets up the directive controller
  // and adds an accordion CSS class to itself element.
  .directive('sumtSection', [function () {
    return {
      restrict: 'EA',
      transclude: true,
      replace: false,
      scope: {
        heading: '@',
        expandedIconClass: '@',
        collapsedIconClass: '@',
        contextualClass: '@'
      },
      templateUrl: 'section/section_view.html',
      link: function (scope, element, attrs) {
        var allowedContextualClasses = ['primary', 'success', 'info', 'warning', 'danger'];

        if (angular.isDefined(attrs.id)) {
          scope.panelId = attrs.id + '_panel';
        }

        function changeState () {
          scope.isCollapsed = !scope.isCollapsed;
        }

        function handleClick (evt) {
          changeState();
        }

        function handleKeyUp (evt) {
          if (evt.keyCode === 13 || evt.keyCode === 32) {
            if (evt.preventDefault) evt.preventDefault();
            if (evt.stopPropagation) evt.stopPropagation();

            changeState();
          }
        }

        scope.isCollapsed = false;

        scope.$click = handleClick;
        scope.$keyUp = handleKeyUp;

        scope.heading = attrs.heading;
        scope.headerToggleOpen = scope.expandedIconClass !== undefined && scope.expandedIconClass !== '' ? scope.expandedIconClass : 'fa fa-caret-down';
        scope.headerToggleClosed = scope.collapsedIconClass !== undefined && scope.collapsedIconClass !== '' ? scope.collapsedIconClass : 'fa fa-caret-right';

        scope.setPanelClass = function () {
          var panelClass = 'panel',
            contextualClass = allowedContextualClasses.indexOf(scope.contextualClass) > -1 ? scope.contextualClass : 'primary';

          if (scope.contextualClass) {
            panelClass += ' ' + (contextualClass.indexOf('panel-') >= 0 ? contextualClass : ('panel-' + contextualClass));
          } else {
            panelClass += ' panel-default';
          }

          scope.panelClass = panelClass;
        };

        //setup the class
        scope.setPanelClass();
      }
    };
}]);

/* jshint strict:false  */
angular.module("SumTotalSidePanel", [])
.directive('sidepanel', function () {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    templateUrl: 'sidepanel/sidepanel_view.html',
    scope: {
      header: '@',
      panels: '&'
    },
    link: function (scope, element, attrs) { //jshint ignore:line

    }
  };
});

/* jshint strict:false */
angular.module("SumTotalSlideOutModule", [])
  .directive('slideout', ['MultiTransclude', '$slideout', '$compile', function (MultiTransclude, $slideout, $compile) {
    return {
      restrict: 'EA',
      transclude: true,
      replace: true,
      scope: {
        showLeftSide: '=',
        hasTemplate: '=',
        key: '@',
        containerSelector: '@',
        showCollapse: '=',
        maintainFocus: '=',
        focusElementOnExpand: '@',
        hasIframe: '='
      },
      templateUrl: 'slideout/slideout_view.html',
      link: function (scope, element, attrs, ctrl, transcludeFn) {
        //register with the provider
        scope.slideProvider = $slideout;

        //if no target container is passed in append to the body tag
        scope.parentContainer = scope.containerSelector ? angular.element(scope.containerSelector) : angular.element("body");

        //keep focus within the slideout as long as it is open, unless the UI wants to override
        scope.maintainFocus = scope.maintainFocus != null && scope.maintainFocus != undefined ? scope.maintainFocus : true;
        
        //get the id of the slideout, this will be used in aria-labelledby        
        attrs.id = attrs.id != null && attrs.id != undefined ? attrs.id : '';

        scope.hasIframe = scope.hasIframe != null && scope.hasIframe != undefined ? scope.hasIframe : false;

        scope.slideOutObject = scope.slideProvider.getSlideOut(scope.key);
        if (scope.slideOutObject) {
          //if slideout is being added to different container, always remove and add while redrawing.
          if (scope.containerSelector) {
            scope.parentContainer.find("div[key='" + scope.key + "']").remove();
            scope.slideOutObject.appended = false;
          }
        } else {
          scope.slideProvider.addSlideOut(scope.key, scope.showCollapse, scope.maintainFocus, scope.focusElementOnExpand, attrs.id, scope.hasIframe);
          scope.slideOutObject = scope.slideProvider.getSlideOut(scope.key);
        }

        scope.showLeft = scope.showLeftSide != null && scope.showLeftSide != undefined ? scope.showLeftSide : true;
        scope.showCollapse = scope.showCollapse != null && scope.showCollapse != undefined ? scope.showCollapse : false;
        scope.getContainerClass = function () {
          var retArgs = '';
          if (!scope.slideOutObject.closed) {
            var previousKey = scope.slideProvider.getPreviousKey();
            if (!previousKey && previousKey != scope.key)
              retArgs += ' slideout-open';
            else
              retArgs += ' slideout-open-fade';
          } else {
            retArgs != 'slideout-closed';
          }

          if (scope.slideOutObject.expand) {
            retArgs += ' slideout-fullopen';
          }
          if (scope.showCollapse && scope.slideOutObject.collapsed) {
            retArgs += ' collapsed';
          }
		  
		  if(typeof(scope.slideProvider.showHeader) != 'undefined' && !scope.slideProvider.showHeader){
			retArgs += ' slideout-displaytop';
		  }
          return retArgs;
        };
        //Handle watches adding too many slide outs to the page.
        if (scope.parentContainer && !scope.slideOutObject.appended) {
          scope.parentContainer.append(element);
          scope.slideOutObject.appended = true;
        }
      }
    };
  }]);
/* jshint strict:false  */
angular.module("SumTotalTabModule", [])
.controller('tabctrl', ["$scope", function ($scope) {
  $scope.tabs = [
      {
        "title": "Home",
        "content": "Dat raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica."
      },
      {
        "title": "Profile",
        "content": "Food truck fixie locavore, accusamus mcsweeney's marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee."
      },
      {
        "title": "About",
        "content": "Etsy mixtape wayfarers, ethical wes anderson tofu before they sold out mcsweeney's organic lomo retro fanny pack lo-fi farm-to-table readymade."
      },
      {
        "title": "Contact",
        "content": "Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid."
      }
    ];
}]);

/* jshint strict:false */
angular.module("SumTotalTimeline", [])
  .directive('sumtTimeline', ["$filter", function ($filter) {
      return {
        restrict: 'EA',
        transclude: true,
        scope: {
          data: '=',
          config: '=',
          hasFilter: '@',
          highlight: '@'
        },
        templateUrl: 'timeline/timeline_view.html',
        link: function (scope, element, attrs) { // jshint ignore:line
          scope.filter = attrs.hasFilter !== undefined && attrs.hasFilter === 'false' ? attrs.hasFilter : true;
          scope.nodes = [];
          scope.tabs = [];
          scope.selectedTab;
          scope.date = new Date();
          scope.compDate = $filter('date')(scope.date, "MM/dd/yyyy");
          this.addDataNode = function (data) {
            scope.nodes.push(data);
          };

          this.setConfig = function (config) {
            scope.tabs.push(config);
          };

          if (scope.config !== undefined) {
            angular.forEach(scope.config, function (item) {
              this.setConfig(item);
            });
            scope.selectedTab = scope.tabs[0];
          }

          if (attrs.stagger !== undefined && attrs.stagger === 'false') {
            scope.stagger = false;
          } else {
            scope.stagger = true;
          }

          if (attrs.highlight !== undefined && attrs.highlight === 'false') {
            scope.highlight = false;
          } else {
            scope.highlight = true;
          }

          scope.setTabSelection = function(tab){
            scope.selectedTab = tab;
            scope.nodes = [];
            angular.forEach(scope.data, function (item) {
              if(item.type == tab.type || tab.type == 'all')
                scope.nodes.push(item);
            });
          }
        }
      };
    }
    ]);

/* jshint strict:false  */
angular.module("SumTotalTooltipModule", [])
.controller("toolTipControl", ["$scope", function ($scope) {
    $scope.dynamicTooltip = "Hello, World!";
    $scope.dynamicTooltipText = "dynamic";
    $scope.htmlTooltip = "I've been made <b>bold</b>!";
}]);

/* jshint strict:false  */
angular.module("SumTotalWebpartModule", [])
  .directive('sumtWebpart', function () {
    return {
      restrict: "A",
      scope: true,
      replace: false,
      templateUrl: 'webparts/webpartcontainer_view.html',
      transclude: true,
      link: function (scope, element, attrs) {

        //var defaultClass = 'sumt-webpart-header ';
        var headerClass = attrs.headerClass === '' || attrs.headerClass === undefined ? '' : attrs.headerClass;

        scope.headerTitle = attrs.headerTitle !== '' && attrs.headerTitle !== undefined ? attrs.headerTitle : '';
        scope.headerClass = headerClass;

        scope.headerIcon = attrs.headerIcon !== '' && attrs.headerIcon !== undefined ? attrs.headerIcon : '';

        scope.hideHeader = attrs.hideHeader !== '' && attrs.hideHeader !== undefined ? attrs.hideHeader : false;
        //console.log(scope.headerUrl);
        scope.headerUrl = attrs.headerUrl !== '' && attrs.headerUrl !== undefined ? attrs.headerUrl : false;
        scope.hideDeeplink = attrs.hideDeeplink !== '' && attrs.hideDeeplink !== undefined && attrs.hideDeeplink.toLowerCase() == 'true' ? true : false;
        scope.contentWidth = attrs.contentWidth !== '' && attrs.contentWidth !== undefined ? attrs.contentWidth : undefined;
        scope.contentHeight = attrs.contentHeight !== '' && attrs.contentHeight !== undefined ? attrs.contentHeight : undefined;
        scope.contentClass = attrs.contentClass !== '' && attrs.contentClass !== undefined ? attrs.contentClass : undefined;

        scope.widthObj = {
          width: scope.contentWidth
        };
        scope.heightObj = {
          height: scope.contentHeight
        };
        if (!scope.hideDeeplink) {
          scope.handleHeaderClick = function () {
            window.eval(scope.headerUrl); // jshint ignore:line
          };
        }
        if (scope.headerUrl !== '' && scope.headerUrl !== undefined && !scope.hideDeeplink) {
            scope.headerLinkIcon = 'fa fa-external-link-square';
            scope.headerStyleObj = {
              cursor: "pointer"
            };
          //element.on("click", function () { window.eval(scope.headerUrl); });
        }
      }
    };
  });

/* jshint strict:false */

angular.module('SumTotalTypeahead', ['mgcrea.ngStrap.tooltip', 'mgcrea.ngStrap.helpers.parseOptions'])

.provider('$sumttypeahead', function () {

  var defaults = this.defaults = {
    animation: 'am-fade',
    prefixClass: 'typeahead',
    prefixEvent: '$sumttypeahead',
    placement: 'bottom-left',
    template: 'typeahead/typeahead.tpl.html',
    trigger: 'focus',
    container: false,
    keyboard: true,
    html: false,
    delay: 0,
    minLength: 1,
    filter: 'filter',
    limit: 6,
    comparator: ''
  };

  this.$get = function ($window, $rootScope, $tooltip, $timeout) {

    function TypeaheadFactory(element, controller, config) {

      var $sumttypeahead = {};

      // Common vars
      var options = angular.extend({}, defaults, config);

      $sumttypeahead = $tooltip(element, options);
      var parentScope = config.scope;
      var scope = $sumttypeahead.$scope;

      scope.$resetMatches = function () {
        scope.$matches = [];
        scope.$activeIndex = -1;
      };
      scope.$resetMatches();

      scope.$activate = function (index) {
        scope.$$postDigest(function () {
          $sumttypeahead.activate(index);
        });
      };

      scope.$select = function (index) {
        scope.$$postDigest(function () {
          $sumttypeahead.select(index);
        });
      };

      scope.$isVisible = function () {
        return $sumttypeahead.$isVisible();
      };

      // Public methods

      $sumttypeahead.update = function (matches) {
        scope.$matches = matches;
        if (scope.$activeIndex >= matches.length) {
          scope.$activeIndex = -1;
        }
        return true;
      };

      $sumttypeahead.activate = function (index) {
        scope.$activeIndex = index;
      };

      $sumttypeahead.select = function (index) {
        var value = scope.$matches[index].value;
        // console.log('$setViewValue', value);
        controller.$setViewValue(value);
        controller.$render();
        scope.$resetMatches();
        if (parentScope) parentScope.$digest();
        // Emit event
        scope.$emit(options.prefixEvent + '.select', value, index, $sumttypeahead);
      };

      // Protected methods

      $sumttypeahead.$isVisible = function () {
        if (!options.minLength || !controller) {
          return !!scope.$matches.length;
        }
        // minLength support
        return scope.$matches.length && angular.isString(controller.$viewValue) && controller.$viewValue.length >= options.minLength;
      };

      $sumttypeahead.$getIndex = function (value) {
        var l = scope.$matches.length,
          i = l;
        if (!l) return;
        for (i = l; i--;) {
          if (scope.$matches[i].value === value) break;
        }
        if (i < 0) return;
        return i;
      };

      $sumttypeahead.$onMouseDown = function (evt) {
        // Prevent blur on mousedown
        evt.preventDefault();
        evt.stopPropagation();
      };

      $sumttypeahead.$onKeyDown = function (evt) {
        if (!/(38|40|13)/.test(evt.keyCode)) return;

        // Let ngSubmit pass if the typeahead tip is hidden
        if ($sumttypeahead.$isVisible() && evt.keyCode !== 13) {
          evt.preventDefault();
          evt.stopPropagation();
        }

        // Select with enter
        if (evt.keyCode === 13 && scope.$matches.length && scope.$activeIndex >= 0) {
          $sumttypeahead.select(scope.$activeIndex);
        } else if (evt.keyCode === 13 && scope.$matches.length && scope.$activeIndex >= 0) {
          return;
        } else if (evt.keyCode === 38 && scope.$activeIndex > 0) scope.$activeIndex--; // Navigate with keyboard
        else if (evt.keyCode === 40 && scope.$activeIndex < scope.$matches.length - 1) scope.$activeIndex++;
        else if (angular.isUndefined(scope.$activeIndex)) scope.$activeIndex = 0;
        scope.$digest();
      };

      // Overrides

      var show = $sumttypeahead.show;
      $sumttypeahead.show = function () {
        show();
        // use timeout to hookup the events to prevent
        // event bubbling from being processed imediately.
        $timeout(function () {
          $sumttypeahead.$element.on('mousedown', $sumttypeahead.$onMouseDown);
          if (options.keyboard) {
            element.on('keydown', $sumttypeahead.$onKeyDown);
          }
        }, 0, false);
      };

      var hide = $sumttypeahead.hide;
      $sumttypeahead.hide = function () {
        $sumttypeahead.$element.off('mousedown', $sumttypeahead.$onMouseDown);
        if (options.keyboard) {
          element.off('keydown', $sumttypeahead.$onKeyDown);
        }
        hide();
      };

      return $sumttypeahead;

    }

    TypeaheadFactory.defaults = defaults;
    return TypeaheadFactory;

  };

  this.$get.$inject = ['$window', '$rootScope', '$tooltip', '$timeout'];
})

.directive('sumtTypeahead', ['$window', '$parse', '$q', '$sumttypeahead', '$parseOptions',
                             function ($window, $parse, $q, $sumttypeahead, $parseOptions) {

    var defaults = $sumttypeahead.defaults;

    return {
      restrict: 'EAC',
      require: 'ngModel',
      link: function postLink(scope, element, attr, controller) {

        // Directive options
        var options = {
          scope: scope
        };
        angular.forEach(['placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'template', 'filter', 'limit', 'minLength', 'watchOptions', 'selectMode', 'comparator', 'id'], function (key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });

        // Build proper ngOptions
        var filter = options.filter || defaults.filter;
        var limit = options.limit || defaults.limit;
        var comparator = options.comparator || defaults.comparator;

        var ngOptions = attr.ngOptions;
        if (filter) ngOptions += ' | ' + filter + ':$viewValue';
        if (comparator) ngOptions += ':' + comparator;
        if (limit) ngOptions += ' | limitTo:' + limit;
        var parsedOptions = $parseOptions(ngOptions);

        // Initialize typeahead
        var typeahead = $sumttypeahead(element, controller, options);

        // Watch options on demand
        if (options.watchOptions) {
          // Watch ngOptions values before filtering for changes, drop function calls
          var watchedOptions = parsedOptions.$match[7].replace(/\|.+/, '').replace(/\(.*\)/g, '').trim();
          scope.$watch(watchedOptions, function () {
            // console.warn('scope.$watch(%s)', watchedOptions, newValue, oldValue);
            parsedOptions.valuesFn(scope, controller).then(function (values) {
              typeahead.update(values);
              controller.$render();
            });
          }, true);
        }

        // Watch model for changes
        scope.$watch(attr.ngModel, function (newValue) {
          // console.warn('$watch', element.attr('ng-model'), newValue);
          scope.$modelValue = newValue; // Publish modelValue on scope for custom templates
          parsedOptions.valuesFn(scope, controller)
            .then(function (values) {
              // Prevent input with no future prospect if selectMode is truthy
              // @TODO test selectMode
              if (options.selectMode && !values.length && newValue.length > 0) {
                controller.$setViewValue(controller.$viewValue.substring(0, controller.$viewValue.length - 1));
                return;
              }
              if (values.length > limit) values = values.slice(0, limit);
              var isVisible = typeahead.$isVisible();
              isVisible && typeahead.update(values);
              // Do not re-queue an update if a correct value has been selected
              if (values.length === 1 && values[0].value === newValue) return;
              !isVisible && typeahead.update(values);
              // Queue a new rendering that will leverage collection loading
              controller.$render();
            });
        });

        // modelValue -> $formatters -> viewValue
        controller.$formatters.push(function (modelValue) {
          // console.warn('$formatter("%s"): modelValue=%o (%o)', element.attr('ng-model'), modelValue, typeof modelValue);
          var displayValue = parsedOptions.displayValue(modelValue);
          return displayValue === undefined ? '' : displayValue;
        });

        // Model rendering in view
        controller.$render = function () {
          // console.warn('$render', element.attr('ng-model'), 'controller.$modelValue', typeof controller.$modelValue, controller.$modelValue, 'controller.$viewValue', typeof controller.$viewValue, controller.$viewValue);
          if (controller.$isEmpty(controller.$viewValue)) return element.val('');
          var index = typeahead.$getIndex(controller.$modelValue);
          var selected = angular.isDefined(index) ? typeahead.$scope.$matches[index].label : controller.$viewValue;
          selected = angular.isObject(selected) ? parsedOptions.displayValue(selected) : selected;
          element.val(selected ? selected.toString().replace(/<(?:.|\n)*?>/gm, '').trim() : '');
        };

        // Garbage collection
        scope.$on('$destroy', function () {
          if (typeahead) typeahead.destroy();
          options = null;
          typeahead = null;
        });

      }
    };

}]);

  /* jshint strict:false */
  angular.module("SumTotalWizard", [])
    .directive('sumtWizard', [function () {
      return {
        restrict: 'EA',
        replace: false,
        transclude: false,
        templateUrl: 'wizard/wizardsteps_view.html',
        scope: {
          activeStep: '=',
          nextStep: '=',
          prevStep: '=',
					stepData: '='
        },
        link: function (scope, element, attrs) { // jshint ignore:line
          scope.stepArray = [];
          scope.stepCount = attrs.numSteps;
					if(scope.stepData!=null)
					{
							angular.forEach(scope.stepData, function(value, key) {
									var step = {
									stepNum: value.stepNum,
									stepName: value.stepName
								};
								scope.stepArray.push(step);
							});
					}
					else
					{
						for (var i = 1; i <= attrs.numSteps; i++) {
							var step = {
								stepNum: i,
								stepName: ''
							};

							scope.stepArray.push(step);
						}
					}

          if (attrs.allowDisable !== undefined) {
            scope.disabled = true;
          } else {
            scope.disabled = false;
          }


          scope.nextStep = function () {
            if (scope.activeStep < scope.stepCount) {
              scope.activeStep += 1;
            }
          };

          scope.prevStep = function () {
            if (scope.activeStep > 1) {
              scope.activeStep -= 1;
            }
          };
        }
      };
}]);

angular.module("SumTotalSlideOutModule")
  .factory("MultiTransclude", ['$compile', function ($compile) {
    return {
      transclude: function (elem, transcludeFn, scope) {
        transcludeFn(function (clone) {
          angular.forEach(clone, function (cloneEl) {
            if (cloneEl.attributes) {
              var destinationId = cloneEl.attributes["transclude-to"].value;
              var destination = angular.element(elem[0].querySelector('[transclude-id="' + destinationId + '"]'));
              if (destination.length) {
                destination.append(cloneEl);
              } else {
                cloneEl.remove();
              }
            }
          });
        });
      }
    };
  }]);

angular.module("SumTotalSlideOutModule")
  .provider('$slideout', function () {
    var _slideOutsHash = {};
    var _currentKey = null;
    var _previousKey = null;
    var _addSlideOut = function (key, collapsible, maintainFocus, focusElementOnExpand, slideoutId, hasIframe) {
      var myScopeObject = {
        closed: true,
        fullOpen: false,
        showLimit: 3,
        toggleLimit: false,
        expand: false,
        appended: false,
        collapsed: false,
        collapsible: collapsible ? collapsible : false,
        maintainFocus: maintainFocus,
        focusElementOnExpand: focusElementOnExpand,
        slideoutId: slideoutId,
        hasIframe: hasIframe
      };

      if (!_slideOutsHash[key]) {
        _slideOutsHash[key] = myScopeObject;
      }
    };

    function _closeCurrent() {
      if (_currentKey) {
        _slideOutsHash[_currentKey].closed = true;
        _slideOutsHash[_currentKey].expand = false;
        _previousKey = _currentKey;

        if (_slideOutsHash[_currentKey].collapsible)
          _slideOutsHash[_currentKey].collapsed = false;
      }
    }

    function _maintainFocus() {
      if (_currentKey) {
        //get the slideout container
        var slideoutContainer = $('div[key="' + _currentKey + '"]');

        /* If there is an iframe on this slideout, then apend a hidden element to the container so that iframe
         * has an element to move focus to. That way focus will remain within the slideout. Otherwise, focus shits to address bar after iframe. 
         * Make sure the hidden element is added only once as this method gets called multiple times. */

        if (_slideOutsHash[_currentKey].hasIframe && $('#idHiddenButton').length <= 0) {

          var hiddenButton = document.createElement("button");
          hiddenButton.id = "idHiddenButton";
          hiddenButton.style = "opacity: 0"
          hiddenButton.setAttribute("aria-hidden", "true");

          slideoutContainer[0].appendChild(hiddenButton);
        }

        slideoutContainer.keydown(function (event) {
          var elementsList = $('div[key="' + _currentKey + '"] :tabbable');

          var noOfElements = elementsList.length;
          if (event.keyCode == 9 && event.shiftKey == false) {
            if (event.target === elementsList[noOfElements - 1]) {
              event.preventDefault();
              setTimeout(function () {
                elementsList[1].focus(); //after the last element, do not focus on the slideout container
              })
            }
            else if (event.target.type == 'radio') {
              var nameAtt = event.target.getAttribute('name');
              if (elementsList[noOfElements - 1].type == 'radio' && elementsList[noOfElements - 1].getAttribute('name') == nameAtt) {
                event.preventDefault();
                elementsList[0].focus();
              }
            }
          }
          else if (event.keyCode == 9 && event.shiftKey == true) {
            if (event.target === elementsList[1]) {
              event.preventDefault();
              setTimeout(function () {
                elementsList[noOfElements - 1].focus();
              })
            }
          }
        })
      }
    }
    function _focusSlideout(key, focusElement) {
      //UI can provide the specific element it wants to focus on open. By default, we will focus on the main slideout container
      if (focusElement == undefined)
        focusElement = '.sumt-slideout';

      var container = $('div[key="' + key + '"]').find(focusElement);
      if (container.length > 0)
        setTimeout(function () {
          container[0].focus();
        }, 500);
      else {
        //assume we didn't find the element, probably first time open.  Allow the dom a second to update and try to grab it again
        if (focusElement !== null && focusElement !== undefined)
          setTimeout(function () {
            container = $('div[key="' + key + '"]').find(focusElement);
            if (container.length > 0)
              container[0].focus();
          }, 500);
      }
    }
    function _toggleSlideout(key, state, focusElementOnExpand) {
      switch (state) {
        case "open":
          _closeCurrent();
          _slideOutsHash[key].collapsed = false;
          _slideOutsHash[key].closed = false;
          _slideOutsHash[key].expand = false;
          _currentKey = key;
          //when slideout is partially open, then maintain focus based on the property sent by UI
          if (_slideOutsHash[key].maintainFocus)
            _maintainFocus();
          break;
        case "close":
          _slideOutsHash[key].collapsed = false;
          _slideOutsHash[key].closed = true;
          _slideOutsHash[key].expand = false;
          _currentKey = null;
          _previousKey = null;
          break;
        case "fullopen":
          _closeCurrent();
          _slideOutsHash[key].collapsed = false;
          _slideOutsHash[key].closed = false;
          _slideOutsHash[key].expand = true;
          _currentKey = key;
          //when slideout is fully open, the always maintain focus within itself
          _maintainFocus();
          break;
        case "collapse":
          _slideOutsHash[key].collapsed = true;
          _slideOutsHash[key].closed = true;
          _slideOutsHash[key].expand = false;
      }
    }
    this.$get = ['$log', '$injector', '$translate', '$q', function ($log, $injector, $translate, $q) {
      var slideOutHash = _slideOutsHash;

      return {
        getSlideOut: function (key) {
          return slideOutHash[key];
        },
        addSlideOut: function (key, collapsible, maintainFocus, focusElementOnExpand, slideoutId, hasIframe) {
          _addSlideOut(key, collapsible, maintainFocus, focusElementOnExpand, slideoutId, hasIframe);
        },
        open: function (key, targetSource) {
          var performAction = true;

          if (_slideOutsHash[key]) {
            if (_slideOutsHash[key].onOpen) {
              performAction = _slideOutsHash[key].onOpen();
            }

            //when opened partially or collapsed from full open, the focus will go to the main container.
            _focusSlideout(key);
            if (targetSource) {
              _slideOutsHash[key].targetSource = targetSource;
            }
          }

          if (performAction !== false) {
            _toggleSlideout(key, "open");
          }
        },
        closeCurrent: function () {
          _closeCurrent();
        },
        getCurrentKey: function () {
          return _currentKey;
        },
        getCurrent: function () {
          return slideOutHash[_currentKey];
        },
        fullOpen: function (key, focusElementOnExpand, targetSource) {
          var performAction = true;

          if (_slideOutsHash[key]) {
            if (_slideOutsHash[key].onFullOpen) {
              performAction = _slideOutsHash[key].onFullOpen();
            }
            if (targetSource) {
              _slideOutsHash[key].targetSource = targetSource;
            }
          }
          if (performAction !== false) {
            _toggleSlideout(key, "fullopen", focusElementOnExpand);
          }
          //focus on the slideout or element provided, needed to wait for the slideout contents to show itself for this to work
          _focusSlideout(key, focusElementOnExpand === undefined || focusElementOnExpand === null ? _slideOutsHash[key].focusElementOnExpand : focusElementOnExpand);
        },
        close: function (key) {
          if (key && _slideOutsHash && _slideOutsHash[key]) {
            var performAction = true;
            if (_slideOutsHash[key].onClose) {
              performAction = _slideOutsHash[key].onClose();
            }

            if (performAction !== false) {
              _toggleSlideout(key, "close");
            }
            if (_slideOutsHash[key].targetSource && _slideOutsHash[key].targetSource.currentTarget) {
              setTimeout(function () {
                angular.element($(_slideOutsHash[key].targetSource.currentTarget)).focus();
              });
            }
          } else if (!key && _currentKey) {
            this.close(_currentKey);
          }
        },
        collapse: function (key) {
          if (key && _slideOutsHash && _slideOutsHash[key]) {
            _toggleSlideout(key, "collapse");
          }
        },
        getPrevious: function () {
          return _slideOutsHash[_previousKey];
        },
        getPreviousKey: function () {
          return _previousKey;
        },
        focusSlideout: _focusSlideout
      };
    }];
  });
angular.module("SumTotalComponents").run(["$templateCache", function($templateCache) {$templateCache.put("accordion/accordion-group_view.html","<div class=\"sumt-accordion-group\">\n  <div class=\"sumt-accordion-heading\" ><a class=\"sumt-accordion-toggle\" ng-click=\"isOpen = !isOpen\" accordion-transclude=\"heading\">{{heading}}</a></div>\n  <div class=\"sumt-accordion-body\" collapse=\"!isOpen\">\n    <div class=\"sumt-accordion-inner\" ng-transclude></div>  \n  </div>\n</div>\n");
$templateCache.put("accordion/accordion_view.html","<section accordion heading=\"Goals\">\n  <h2>{{heading}}</h2>\n  <div accordion-group heading=\"\">\n    <div ng-transclude />\n  </div>\n</section>\n");
$templateCache.put("angular-strap/alert.html","<div aria-live=\"assertive\" role=\"alert\" class=\"alert\" ng-class=\"[type ? \'alert-\' + type : null]\">  \n  <strong role=\"heading\" ng-bind=\"title\"></strong>&nbsp;<span ng-bind-html=\"content\"></span>\n  <button role=\"button\" type=\"button\" class=\"close\" ng-if=\"dismissable\" ng-click=\"$hide()\"><span class=\"fa fa-close\"></span><span class=\"sr-only\" translate=\"CLOSE_TXT\"></span></button>\n</div>");
$templateCache.put("angular-strap/datepicker.html","<div role=\"presentation\" aria-hidden=\"true\" class=\"dropdown-menu datepicker\" ng-class=\"\'datepicker-mode-\' + $mode\" style=\"max-width: 320px;\">\n  <table style=\"table-layout: fixed; height: 100%; width: 100%;\">\n    <thead>\n      <tr class=\"text-center\">\n        <th>\n          <button tabindex=\"-1\" type=\"button\" class=\"btn btn-default pull-left\" ng-click=\"$selectPane(-1)\">\n            <i class=\"{{$iconLeft}}\"></i>\n          </button>\n        </th>\n        <th colspan=\"{{ rows[0].length - 2 }}\">\n          <button tabindex=\"-1\" type=\"button\" class=\"btn btn-default btn-block text-strong\" ng-click=\"$toggleMode()\">\n            <strong style=\"text-transform: capitalize;\" ng-bind=\"title\"></strong>\n          </button>\n        </th>\n        <th>\n          <button tabindex=\"-1\" type=\"button\" class=\"btn btn-default pull-right\" ng-click=\"$selectPane(+1)\">\n            <i class=\"{{$iconRight}}\"></i>\n          </button>\n        </th>\n      </tr>\n      <tr ng-if=\"showLabels\" ng-bind-html=\"labels\"></tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"(i, row) in rows\" height=\"{{ 100 / rows.length }}%\">\n        <td class=\"text-center\" ng-repeat=\"(j, el) in row\">\n          <button tabindex=\"-1\" type=\"button\" class=\"btn btn-default\" style=\"width: 100%\" ng-class=\"{\'btn-primary\': el.selected, \'btn-info btn-today\': el.isToday && !el.selected}\" ng-click=\"$select(el.date)\" ng-disabled=\"el.disabled\">\n            <span ng-class=\"{\'text-muted\': el.muted}\" ng-bind=\"el.label\"></span>\n          </button>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n");
$templateCache.put("claw/claw_view.html","<div ng-show=\"clawVisible\" class=\"clawBubbleContainer\" ng-style=\"{width: chartWidth}\">\n  <div class=\"clawContainer\" ng-style=\"{width: canvas.width}\">\n    <div class=\"clawheader\">\n      <span class=\"h4\" ng-style=\"{width: cX}\">{{gapCount}} <label for=\"gapCount\" translate=\"POSITIONFIT_GAPCOUNT\"></label></span>\n      <div class=\"legendContainer\" ng-style=\"{left: canvas.width - legendWidth}\" aria-describedby=\"legendTable\">\n        <table>\n          <tr>\n            <td><span class=\"h4\" translate=\"POSITIONFIT_IMPACTCAPABILITY\"></span></td>\n            <td ng-repeat-start=\"c in config.legendColors.slice().reverse()\">\n              <div class=\"legendRec\" ng-style=\"{background: getColor(c)}\"></div>\n            </td>\n            <td ng-repeat-end ng-hide=\"$last == true\">\n              <i class=\"fa fa-arrow-right\"></i>\n            </td>\n          </tr>\n          <tr>\n            <td></td>\n            <td ng-repeat-start=\"c in config.legendColorLabels.slice().reverse()\" translate=\'{{c}}\'></td>\n            <td ng-repeat-end ng-hide=\"$last == true\"></td>\n          </tr>\n        </table>\n      </div>\n    </div>\n    <canvas id=\"clawCanvas\" height={canvas.height} width={canvas.width} aria-describedby=\"clawTable\"></canvas>\n    <canvas tooltip=\"\" id=\"clawtip\" width=100 height=25></canvas>\n    <div class=\"sr-only\" id=\"clawTable\">\n      <table ng-repeat=\"item in data\">\n        <tr>\n          <td colspan=\"2\">{{::item.id}}</td>\n        </tr>\n        <tr ng-repeat=\"i in item.items\">\n          <td>{{::i.name}}</td>\n          <td>{{::i.percent}}</td>\n        </tr>\n      </table>\n    </div>\n    <div class=\"clawLabelContainer\">\n      <span class=\"h5\" ng-style={width:cX} translate=\"POSITIONFIT_CLAWLABEL\"></span>\n      <span class=\"h5\" ng-style={width:competencyWidth} translate=\"POSITIONFIT_CAPABILITY\"></span>\n      <span class=\"h5\" ng-style={width:labelStyle} translate=\"POSITIONFIT_CURRENT_CAPABILITY\"></span>\n    </div>\n    <div class=\"clawListContainer\">\n      <div ng-transclude ng-if=\"transclusion\"></div>\n      <div ng-if=\"!transclusion\">\n        <table class=\"table table-responsive\" ng-if=\"tableDisplayContent==\'Gaps\'\">\n          <thead>\n            <tr>\n              <th translate=\"POSITIONFIT_TABLEHEADER_NAME\"></th>\n              <th translate=\"POSITIONFIT_TABLEHEADER_DESCRIPTION\"></th>\n              <th translate=\"POSITIONFIT_TABLEHEADER_IMPACT\"></th>\n              <th>&nbsp;</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"i in selectedGap.items\" style=\"height:62px\">\n              <td class=\"clawTableWordBreak clawTableNameCol\"> {{i.name | limitTo: 100}}{{i.name.length>100?\'...\':\'\'}}</td>\n              <td class=\"clawTableWordBreak clawTableDescCol\" ng-bind=\"(i.description | limitTo: 250)+(i.description.length>250?\'...\':\'\')\"></td>\n              <td class=\"clawTableWordBreak clawTableValueCol\"> {{i.value}}%</td>\n              <td ng-show=\"selectedGap.categoryName == \'POSITIONFIT_LEARNING\' && i.actions!= null && i.actions.length > 0\" class=\"clawTableWordBreak clawTableActionCol\">\n                <div class=\"btn-group\">\n                  <button type=\"button\" ng-bind=\"i.actions[0].Name\" ng-click=\"activityActionBtnClick(i.actions[0], i.activityId)\" class=\"btn btn-info\"></button>\n                  <button bs-dropdown data-placement=\"bottom-right\" data-template-url=\"positionFitDropdown\" type=\"button\"\n                          class=\"btn btn-info dropdown-toggle clawGapSplitButton\" data-toggle=\"dropdown\" aria-expanded=\"false\">\n\n                    <span class=\"caret\"></span>\n                    <span class=\"sr-only\" />\n                  </button>\n                  <script type=\"text/ng-template\" id=\"positionFitDropdown\">\n                    <ul class=\"dropdown-menu  menu-pull-right\" role=\"menu\">\n                      <li ng-click=\"activityActionBtnClick(action, i.activityId)\" ng-repeat=\"action in i.actions\" tabindex=\"-1\" ng-if=\"$index > 0\">\n                        <a ng-bind=\"::action.Name\" />\n                      </li>\n                    </ul>\n                  </script>\n                </div>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        <table class=\"table table-responsive\" ng-if=\"tableDisplayContent==\'POSITIONFIT_SKILLS\'\">\n          <thead>\n            <tr>\n              <th translate=\"POSITIONFIT_TABLEHEADER_SKILL\"></th>\n              <th translate=\"POSITIONFIT_TABLEHEADER_ACQUIRED\"></th>\n              <th translate=\"POSITIONFIT_TABLEHEADER_TARGET\"></th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"i in completedActivities\">\n              <td ng-bind=\"(i.name | limitTo: 100)+(i.name.length>100?\'...\':\'\')\" class=\"clawTableWordBreak clawTableDescCol\"></td>\n              <td ng-bind=\"i.acquiredProficiency\" class=\"clawTableWordBreak clawTableNameCol\"></td>\n              <td ng-bind=\"i.requiredProficiency\" class=\"clawTableWordBreak clawTableNameCol\"></td>\n            </tr>\n          </tbody>\n        </table>\n        <table class=\"table table-responsive\" ng-if=\"tableDisplayContent==\'POSITIONFIT_BEHAVIORS\'\">\n          <thead>\n            <tr>\n              <th translate=\"POSITIONFIT_BEHAVIOR\"></th>\n              <th translate=\"POSITIONFIT_ACQUIRED_PROFICIENCY\"></th>\n              <th translate=\"POSITIONFIT_TARGET_PROFICIENCY\"></th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"i in completedActivities\">\n              <td ng-bind=\"(i.name | limitTo: 100)+(i.name.length>100?\'...\':\'\')\" class=\"clawTableWordBreak clawTableDescCol\"></td>\n              <td ng-bind=\"i.acquiredProficiency\" class=\"clawTableWordBreak clawTableNameCol\"></td>\n              <td ng-bind=\"i.requiredProficiency\" class=\"clawTableWordBreak clawTableNameCol\"></td>\n            </tr>\n          </tbody>\n        </table>\n        <table class=\"table table-responsive\" ng-if=\"tableDisplayContent==\'Headers\'\">\n          <thead>\n            <tr>\n              <th translate=\"POSITIONFIT_TABLEHEADER_GAPDETAILS\"></th>\n              <th translate=\"POSITIONFIT_TABLEHEADER_DESCRIPTION\"></th>\n              <th translate=\"POSITIONFIT_TABLEHEADER_IMPACT\"></th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"i in selectedCapability.items | filter:!{percent : !0}\">\n              <td ng-bind=\"(i.name | limitTo: 100)+(i.name.length>100?\'...\':\'\')\" class=\"clawTableWordBreak clawTableNameCol\"></td>\n              <td class=\"clawTableWordBreak clawTableDescCol\" ng-bind=\"(i.description | limitTo: 250)+(i.description.length>250?\'...\':\'\')\"></td>\n              <td ng-bind=\"i.percent+\'%\'\" class=\"clawTableWordBreak clawTableValueCol\"></td>\n            </tr>\n          </tbody>\n        </table>\n        <table class=\"table table-responsive\" ng-if=\"tableDisplayContent==\'POSITIONFIT_LEARNING\'\">\n          <thead>\n            <tr>\n              <th translate=\"POSITIONFIT_TABLEHEADER_ACTIVITY\"></th>\n              <th translate=\"POSITIONFIT_TABLEHEADER_DATETAKEN\"></th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"i in completedActivities\">\n              <td ng-bind=\"(i.name | limitTo: 100)+(i.name.length>100?\'...\':\'\')\" class=\"clawTableWordBreak clawTableDescCol\"></td>\n              <td ng-bind=\"i.completionDate | date:\'shortDate\'\" class=\"clawTableWordBreak clawTablePercentCol\"></td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("datepicker/datepicker.html","<div class=\"sumt-datepicker form-group\">\n  <label ng-if=\"::labelInput\" class=\"control-label\" ng-attr-for=\"{{::inputId}}\" ng-bind=\"::labelInput | translate\"></label>\n  <input id=\"{{::inputId}}\" ng-attr-title=\"{{::labelInput | translate}}\" type=\"text\" class=\"form-control\" ng-model=\"ngModelDate\"\n         bs-datepicker-display ng-required=\"required\" ng-disabled=\"disabled\" min-date=\"{{minDate}}\" max-date=\"{{maxDate}}\" ng-attr-placeholder=\"{{textboxPlaceholder || undefined}}\"\n         date-format=\"{{dateFormat}}\" timezone=\"{{::timezone}}\" />\n  <button id=\"{{::pickerId}}\" class=\"btn btn-default\" type=\"button\" ng-attr-title=\"{{::labelInput | translate}}\" role=\"button\"\n          bs-datepicker ng-model=\"ngModelDate\" autoclose=\"1\" min-date=\"{{minDate}}\" max-date=\"{{maxDate}}\" trigger=\"click\" container=\"{{container}}\"\n          focus-on-open=\"true\" label-next=\"{{::labelNext | translate}}\" label-previous=\"{{::labelPrevious | translate}}\" label-month=\"{{::labelMonth | translate}}\"\n          label-year=\"{{::labelYear | translate}}\" label-days=\"{{::labelDays | translate}}\" ng-disabled=\"disabled\" data-placement=\"{{::placement}}\"\n          date-format=\"{{::dateFormat}}\" timezone=\"{{::timezone}}\">\n    <i class=\"fa fa-calendar\"></i>\n  </button>\n</div>\n");
$templateCache.put("forms/text.html","<div id=\"formWrapper\" ng-form=\"{{validatedName}}\" class=\"form-group has-feedback\" ng-class=\"getFormGroupClass({{validatedName}}.userinputtext.$invalid, {{validatedName}}.userinputtext.$dirty, {{validatedName}}.userinputtext.$valid)\">\n  <label class=\"control-label\" for=\"exampleForm_usersname\">{{validatedLabel()}}</label>\n  <input type=\"text\" required class=\"form-control\" ng-model=\"controlData\" name=\"userinputtext\" id=\"exampleForm_usersname\" aria-describedby=\"inputSuccess2Status\" />\n  <span class=\"fa fa-check form-control-feedback\" ng-show=\"{{validatedName}}.userinputtext.$valid && {{validatedName}}.userinputtext.$dirty\" aria-hidden=\"true\"></span>\n  <span class=\"fa fa-times form-control-feedback\" ng-show=\"{{validatedName}}.userinputtext.$invalid && {{validatedName}}.userinputtext.$dirty\" aria-hidden=\"true\"></span>\n  <span id=\"inputSuccess2Status\" class=\"sr-only\" ng-show=\"{{validatedName}}.userinputtext.$valid\">(success)</span>\n</div>\n");
$templateCache.put("headerbar/headerbar_view.html","<div ng-multi-transclude-controller class=\"mainContainer\">\n\n    <div id=\"divHeader\" ng-multi-transclude=\"headerArea\" class=\"headerBarContainer\"> </div>\n\n    <div id=\"divContent\" ng-multi-transclude=\"contentArea\" class=\"contentContainer\"> </div>\n</div>\n\n");
$templateCache.put("leftnav/leftnav_content_template_view.html","<div class=\"aside ng-scope left leftnav am-slide-left\" tabindex=\"-1\" role=\"dialog\" style=\"display: block;\">\n  <div class=\"aside-dialog\">\n    <div class=\"aside-content\">\n\n      <div ng-if=\"title.nodeKey  == \'self_header\'\">\n        <div class=\"aside-header\" ng-show=\"title\">\n          <div selfheader persondata=\"persondata\" emulation=\"emulation\" imageclicked=\"imageclicked()\" exitemulation=\"exitemulation()\" />\n          <i class=\"fa fa-times\" ng-click=\"close()\"></i>\n        </div>\n        <div class=\"aside-body\">\n          <nav ng-repeat=\"rootNode in ::navData\" ng-if=\"rootNode == selectedNavData\">\n            <div ui-tree data-drag-enabled=\"false\" id=\"tree-root\" class=\"leftNavigationBackground\">\n              <ul ui-tree-nodes ng-model=\"::rootNode.childNodes\">\n                <li ng-repeat=\"node in ::rootNode.childNodes\" ui-tree-node ng-include=\"\'leftnav_renderer.html\'\" collapsed=\"true\"></li>\n              </ul>\n            </div>\n          </nav>\n        </div>\n      </div>\n      <div ng-if=\"title.nodeKey != \'self_header\'\">\n        <div class=\"aside-header aside-headerSelf\" ng-show=\"title\">\n          <h2 ng-if=\"title.url != null && title.url != \'\'\" class=\"aside-title\" ng-bind=\"title.name\" ng-click=\"navigateToAdmin(title)\" style=\"margin-bottom: 0px;\"></h2>\n          <h2 ng-if=\"(title.url == null || title.url == \'\')\" class=\"aside-title\" ng-bind=\"title.name\"></h2>\n		  <div class=\"domain_Header\" ng-if=\"title.nodeKey == \'admin_header\' && switchdomain.Isenabled\">\n		   <p class=\"aside-title domain_change\" style=\"margin:0px\" bs-tooltip data-placement=\"bottom\" data-title=\"{{switchdomain.name}}\" data-container=\"body\">{{::translationobject.domain}}: {{switchdomain.name}} \n		  <i class=\"fa fa-pencil editDomain domain_editicone\" ng-click=\"navigateToAdmin(switchdomain)\"></i>\n		  <span class=\"editDomain aside-title\" ng-click=\"navigateToAdmin(switchdomain)\">{{::translationobject.edit}}</span>\n		  </p>\n		  </div>\n          <i class=\"fa fa-times\" ng-click=\"close()\"></i>\n        </div>\n        <div class=\"aside-body aside-bodySelf\">\n          <nav ng-repeat=\"rootNode in ::navData\" ng-if=\"rootNode == selectedNavData\">\n            <div ui-tree data-drag-enabled=\"false\" id=\"tree-root\" class=\"leftNavigationBackground\">\n              <ul ui-tree-nodes ng-model=\"::rootNode.childNodes\">\n                <li ng-repeat=\"node in ::rootNode.childNodes\" ui-tree-node ng-include=\"\'leftnav_renderer.html\'\"  collapsed=\"true\"></li>\n              </ul>\n            </div>\n          </nav>\n        </div>\n      </div>\n\n\n\n    </div>\n  </div>\n  <script type=\"text/ng-template\" id=\"leftnav_renderer.html\">\n    <div ui-tree-handle ng-if=\"::(node.level != 1)\" ng-class=\"::{\'negativeAlign\': node.level > 2}\" class=\"tree-node tree-node-content\" tabindex=\"-1\">\n      <i class=\"fa pull-left\" tabindex=\"-1\" ng-class=\"{\'fa-caret-right rightArrow\': collapsed && node.childNodes.length > 0, \'fa-caret-down downArrow\': !collapsed && node.childNodes.length > 0 }\" ng-if=\"::(node.level > 2)\" ng-click=\"handleNodes(node, this)\"></i>\n      <i class=\"{{::node.iconPath}} navnodeicon pull-left\" ng-if=\"::node.iconPath\"></i>\n      <div class=\"tree-node-title clearfix\" ng-if=\"::(node.level != 1)\">\n        <div ng-click=\"handleNodeSelected(node, this)\" style=\"word-wrap: break-word;\">\n          <div ng-if=\"(!collapsed && node.childNodes.length > 0)\" ng-click=\"navigateToNode(node)\" style=\"width: 85%;font-weight: 600;\" class=\"pull-left\" ng-bind=\'::node.activitiesCount>0 ? node.name + \" (\" + node.activitiesCount + \")\" : node.name\' tabindex=\"-1\"></div>\n          <div ng-if=\"(collapsed || node.childNodes.length==0)\" ng-click=\"navigateToNode(node)\" style=\"width: 85%;\" class=\"pull-left\" ng-bind=\'::node.activitiesCount>0 ? node.name + \" (\" + node.activitiesCount + \")\" : node.name\' tabindex=\"-1\"></div>\n        </div>\n        <div ng-if=\"::(node.childNodes.length > 0)\" style=\"width:10%;float:right\">\n          <i class=\"fa fa-lg fa-fw angleArrow pull-right\" ng-class=\"{\'fa-angle-right\': collapsed && node.childNodes.length > 0, \'fa-angle-down\': !collapsed && node.childNodes.length > 0}\" ng-if=\"::(node.level == 2)\" ng-click=\"handleNodes(node, this)\"></i>\n        </div>\n      </div>\n    </div>\n    <ol ui-tree-nodes=\"\" ng-model=\"::node.childNodes\" ng-class=\"{hidden: collapsed, spacing: node.level == 2}\">\n      <li ng-repeat=\"node in ::node.childNodes\" ui-tree-node ng-include=\"\'leftnav_renderer.html\'\" collapsed=\"true\"></li>\n    </ol>\n  </script>\n</div>\n");
$templateCache.put("leftnav/leftnav_panels_view.html","<nav class=\"sidePanelNavContainer\">\n  <ul class=\"nav\">\n    <li ng-repeat=\'panel in ::panels() track by $index\'>\n      <a href=\"{{\'#\'+panel.id}}\" ng-click=\"expand = !expand\" ng-bind=\"::panel.title\"></a>\n      <i ng-if=\"::panel.children\" ng-click=\"expand = !expand\" ng-class=\"expand ? \'fa fa-angle-down\' : \'fa fa-angle-right\'\"></i>\n      <div class=\"sidePanelChildContainer\" ng-show=\"expand\">\n        <div ng-repeat=\'child in ::panel.children\'>\n          <a ng-bind=\"::child.title\"></a>\n        </div>\n      </div>\n    </li>\n  </ul>\n</nav>\n");
$templateCache.put("leftnav/leftnav_view.html","<div class=\"leftNavWrapper asid-slide-left\" ng-class=\"{\'asideExpanded\': leftNavigationObject.isShown}\">\n  <div ng-transclude></div>\n</div>\n");
$templateCache.put("leftnav/self_header.html","<div class=\"left-nav-image\">\n  <div sumt-keymeasure-chart chart-data=\"{{persondata.KeyMeasureValue}}\" chart-width=\"70px\" chart-height=\"70px\" ng-click=\"imageclicked()\">\n	<img ng-if=\"persondata.ImagePath != \'\'\" ng-src=\"{{persondata.ImagePath}}\" class=\"left-nav-headerImage\" ng-click=\"imageclicked()\"></img>\n	<div ng-if=\"persondata.ImagePath == \'\'\" class=\"navheader\" ng-click=\"imageclicked()\">\n		<i  class=\"fa fa-user fa-3x navheadericon\" ></i>\n	</div>\n	</div>\n	<div class=\"left-nav-headertitle\">\n		<p id=\"username\" class=\"left-nav-headerdetails\" ng-bind=\"persondata.FirstName+\' \'+ persondata.LastName\" ng-class=\"{\'left-nav-headerdetails\': !emulation, \'left-nav-headeremulation\': emulation}\" ng-click=\"imageclicked()\"></p>\n		<p class=\"left-nav-headersubtitle\" ng-bind=\"persondata.JobTitle\" ng-click=\"imageclicked()\" bs-tooltip data-placement=\"bottom\" data-title=\"{{persondata.JobTitle}}\" data-container=\"body\"></p>\n		<p class=\"left-nav-exitemulation\"  ng-if=\"emulation && emulation.IsEmulationEnabled == true\" ng-click=\"exitemulation()\">Exit Emulation</p>\n	</div>\n</div>\n\n");
$templateCache.put("notificationTile/notificationTile_view.html","<div ng-repeat=\"notif in notifications track by $index\" ng-show=\"pagination === \'false\' || currentPage === $index + 1\" class=\"notificationTile\" ng-class=\"{\'selected\': selected === true}\">\n  <div class=\"iconContainer\"><i class=\"{{notif.icon}}\"></i></div>\n  <div class=\"notificationSection\" ng-repeat=\"item in notif.sections track by $index\" ng-class=\"getClass(item)\">\n    <h3>{{item.heading}}</h3>\n    <h4>{{item.definition}}</h4>\n  </div>\n  <div ng-show=\"pagination === \'true\'\" class=\"pageContainer\">\n    <div ng-repeat=\"p in getPages() track by $index\" class=\"pageDot\" ng-click=\"setPage($index + 1)\" ng-class=\"{\'pageDotSel\': currentPage !== $index + 1}\"></div>\n  </div>\n  <label ng-show=\"pagination === \'false\'\" class=\"checkBox\"><input ng-model=\"selected\" type=\"checkbox\"/><span></span></label>\n</div>\n");
$templateCache.put("section/section_view.html","<div class=\"section-view\" ng-class=\"[panelClass, {\'expanded\': isCollapsed == false, \'collapsed\': isCollapsed}]\" bs-collapse>\n  <div class=\"panel-heading\">\n    <h2 class=\"panel-title\">\n      <a href=\"\" role=\"button\" bs-collapse-toggle ng-click=\"$click()\" ng-keyup=\"$keyUp($event)\" ng-attr-aria-controls=\"{{panelId || undefined}}\">\n        <i class=\"openIcon\" ng-class=\"::headerToggleOpen\"></i>\n        <span ng-if=\"isCollapsed\" class=\"sr-only\" translate=\"EXPAND_TEXT\"></span>\n        <i class=\"closedIcon\" ng-class=\"::headerToggleClosed\"></i>\n        <span ng-if=\"!isCollapsed\" class=\"sr-only\" translate=\"COLLAPSE_TEXT\"></span> {{::heading}}\n      </a>\n    </h2>\n  </div>\n  <div class=\"panel-collapse\" bs-collapse-target>\n    <div class=\"panel-body\" ng-attr-id=\"{{panelId || undefined}}\" ng-transclude />\n  </div>\n</div>\n");
$templateCache.put("sidepanel/sidepanel_view.html","<div ng-multi-transclude-controller>\n  <div ng-multi-transclude=\"testspot\"></div>\n\n</div>\n\n\n");
$templateCache.put("slideout/slideout_view.html","<div ng-multi-transclude-controller>\n  <div class=\"slideout-backdrop am-fade\" ng-cloak ng-class=\"{\'hideHeatShield\': slideOutObject.closed == true || slideOutObject.closed == false && slideOutObject.expand == false, \'slideout-displaytop\': !slideProvider.showHeader}\"></div>\n  <div class=\"sumt-slideout right\" ng-class=\"getContainerClass()\" role=\"dialog\" ng-hide=\"slideOutObject.closed && !slideOutObject.collapsed\" tabindex=\"0\" aria-labelledby=\"{{slideOutObject.slideoutId}}\">\n    <div class=\"closeTab\" ng-if=\"showCollapse && !slideOutObject.collapsed\" ng-click=\"slideProvider.collapse(key)\"><i class=\"fa fa-chevron-right\"></i></div>\n    <div class=\"closeTab collapsedTab\" ng-if=\"showCollapse && slideOutObject.collapsed\" ng-click=\"slideProvider.open(key)\"><i class=\"fa fa-chevron-left\"></i></div>\n    <div class=\"closeTab\" ng-if=\"!showCollapse\" ng-click=\"slideProvider.close(key)\" ng-attr-aria-label=\"{{\'CLOSE_TXT\' | translate}}\"><i class=\"fa fa-times\"></i></div>\n    <div ng-if=\"hasTemplate\" ng-multi-transclude=\"allcontent\"></div>\n    <div ng-show=\"!hasTemplate && showLeft\" class=\"slideout-left-container\" aria-hidden=\"{{slideOutObject.closed}}\">\n      <div class=\"slideout-inner-left\">\n        <div ng-multi-transclude=\"headersection\" aria-hidden=\"{{slideOutObject.closed}}\"></div>\n        <div ng-multi-transclude=\"sidecontent\" aria-hidden=\"{{slideOutObject.closed}}\"></div>\n      </div>\n    </div>\n    <div ng-show=\"!hasTemplate && slideOutObject.expand\" class=\"slideout-expanded-container\" ng-class=\"{\'no-left-content\': !showLeft, \'arrow-padding\': showLeft}\">\n      <i class=\"fa fa-arrow-right\" ng-click=\"slideProvider.open(key)\" ng-show=\"showLeft && slideOutObject.expand\" ng-attr-aria-label=\"{{\'COLLAPSE_TEXT\' | translate}}\"></i>\n      <div ng-multi-transclude=\"expandcontent\" aria-hidden=\"{{slideOutObject.closed}}\"></div>\n      <div ng-multi-transclude=\"footer\" aria-hidden=\"{{slideOutObject.closed}}\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("timeline/timeline_view.html","<section>\n  <ul ng-show=\"filter == true\" class=\"nav nav-pills nav-justified\">\n    <li ng-repeat=\"tab in tabs\" role=\"presentation\" ng-class=\"{\'active\': tab == selectedTab, \'\': tab != selectedTab}\"><a ng-click=\"setTabSelection(tab)\">{{tab.filter}}</a></li>\n  </ul>\n  <div id=\"cd-timeline\" class=\"cd-container\" ng-class=\"{\'cd-timeline-stagger\': stagger === true}\">\n    <div class=\"cd-timeline-block\" ng-repeat=\"node in data track by $index\">\n      <div class=\"cd-timeline-img cd-picture\" ng-class=\"{\'cd-timeline-img-stagger\': stagger === true}\">\n        <!--      <img ng-show=\"{{node.imageSource}}\" ng-src=\"{{node.imageSource}}\" alt=\"Picture\">-->\n        <i class=\"fa fa-file\"></i>\n      </div>\n      <div class=\"cd-timeline-content\" ng-class=\"{\'cd-timeline-content-stagger\': stagger === true, \'cd-timeline-selected\': (highlight == \'true\' && compDate == node.date) || (node.highlight)}\">\n        <h2>{{node.title}}</h2>\n        <p>{{node.body}}</p>\n        <button ng-href=\"{{node.readMore}}\" class=\"btn btn-primary sumt-btn-primary cd-read-more\" ng-show=\"{{node.readMore !== undefined}}\">Read more</button>\n        <span class=\"cd-date\">{{node.date | date:\"MM/dd/yyyy\"}}</span>\n      </div>\n    </div>\n  </div>\n</section>\n");
$templateCache.put("typeahead/typeaheadwrap.tpl.html","<ul style=\"width:90%\" tabindex=\"-1\" class=\"typeahead dropdown-menu\" ng-show=\"$isVisible()\" role=\"select\">\n	<li style=\"width:94%;word-wrap: break-word;margin-left:10px;\" role=\"presentation\" ng-repeat=\"match in $matches | limitTo: 6\" ng-class=\"{active: $index == $activeIndex}\" >\n        <a style=\"display:list-item;white-space: pre-wrap;word-wrap: break-word;margin-left:10px;text-align: left;line-height:15px;\" role=\"menuitem\" tabindex=\"-1\"  ng-bind-template=\"{{match.label}}\" ng-click=\"$select($index, $event)\"></a>\n    </li>\n	<li ng-if=\"($matches.length > 6)\" style=\"margin-left: 5px;word-wrap: break-word;background-color:#EEEEEE\">\n		<p style=\"text-align: center;word-wrap: break-word;margin-left:5px;Font-size:12px;\">More jobs match your search. Try using more specific keywords to narrow the results</p>\n	</li>\n</ul>\n");
$templateCache.put("webparts/webpartcontainer_view.html","<div class=\"sumt-webpartcontainer\" ng-style=\"widthObj\">\n  <h2 ng-hide=\"hideHeader\" ng-model=\"headerclass\" class=\"{{ headerClass }}\">\n    <i class=\"{{ headerIcon }}\" ng-show=\"headerIcon\"></i>\n    {{headerTitle}}\n    <i ng-model=\"headerLinkIcon\" class=\"{{ headerLinkIcon }}\" ng-click=\"handleHeaderClick()\" ng-show=\"headerLinkIcon\" ng-style=\"headerStyleObj\"></i>\n  </h2>\n  <div class=\"sumt-webpart-content\" ng-style=\"heightObj\" ng-class=\"contentClass\">\n     <div ng-style=\"widthObj\" ng-transclude />\n  </div>\n</div>\n");
$templateCache.put("wizard/wizardsteps_view.html","<ol class=\"progTracker\" role=\"presentation\" ng-class=\"::{\'disabledStyle\':disabled===true}\">\n  <li aria-selected=\"{{step.stepNum == activeStep}}\" ng-repeat=\"step in ::stepArray\" ng-class=\"step.stepNum < activeStep ? \'progTracker-done\' : step.stepNum == activeStep ? \'progTracker-active\' : disabled === true ? \'progTracker-disable\' : \'progTracker-todo\'\">\n    <div ng-class=\"{\'activeStep stepline1 stepline1color\': step.stepNum == activeStep, \'stepline1 stepline2color inactiveStep\': step.stepNum != activeStep && step.stepNum != stepCount, \'lastStep\': step.stepNum == stepCount}\"></div>\n	   <p class=\"steptitle\" ng-bind=\"::step.stepName\"></p>\n	</li>\n</ol>\n");}]);
angular.module('SumTotalComponents')
  .constant('FOUNDATION_TRANSLATIONS', {
    en: {
      CLOSE: 'Close',
      CLOSE_TXT: 'Close'
    },
    de: {
      CLOSE: 'Nah dran',
      CLOSE_TXT: 'Schließen'
    },
    arSA: {
      CLOSE_TXT: 'إغلاق'
    },
    cs: {
      CLOSE_TXT: 'Zavřít'
    },
    da: {
      CLOSE_TXT: 'Luk'
    },
    el: {
      CLOSE_TXT: 'Κλείσιμο'
    },
    enGB: {
      CLOSE_TXT: 'Close'
    },
    esMX: {
      CLOSE_TXT: 'Cerrar'
    },
    es: {
      CLOSE_TXT: 'Cerrar'
    },
    fi: {
      CLOSE_TXT: 'Sulje'
    },
    frCA: {
      CLOSE_TXT: 'Fermer'
    },
    fr: {
      CLOSE_TXT: 'Fermer'
    },
    hu: {
      CLOSE_TXT: 'Bezárás'
    },
    id: {
      CLOSE_TXT: 'Tutup'
    },
    it: {
      CLOSE_TXT: 'Chiudi'
    },
    ja: {
      CLOSE_TXT: '閉じる'
    },
    ko: {
      CLOSE_TXT: '닫기'
    },
    nl: {
      CLOSE_TXT: 'Sluiten'
    },
    no: {
      CLOSE_TXT: 'Lukk'
    },
    pl: {
      CLOSE_TXT: 'Zamknij'
    },
    ptBR: {
      CLOSE_TXT: 'Fechar'
    },
    ro: {
      CLOSE_TXT: 'Închidere'
    },
    ru: {
      CLOSE_TXT: 'Закрыть'
    },
    sl: {
      CLOSE_TXT: 'Zapri'
    },
    sv: {
      CLOSE_TXT: 'Stäng'
    },
    th: {
      CLOSE_TXT: 'ปิด'
    },
    tr: {
      CLOSE_TXT: 'Kapat'
    },
    uk: {
      CLOSE_TXT: 'Закрити'
    },
    vi: {
      CLOSE_TXT: 'Đóng'
    },
    zhHans: {
      CLOSE_TXT: '关闭'
    },
    zhHant: {
      CLOSE_TXT: '關閉'
    }
  });

angular.module('SumTotalComponents').config(['FOUNDATION_TRANSLATIONS', '$translateProvider', '$alertProvider', '$modalProvider',
  function (translations, $translateProvider, $alertProvider, $modalProvider) {

    $translateProvider
      .translations('en', translations.en)
      .translations('de', translations.de)
      .translations('ar-SA', translations.arSA)
      .translations('cs', translations.cs)
      .translations('da', translations.da)
      .translations('el', translations.el)
      .translations('en-GB', translations.enGB)
      .translations('es-MX', translations.esMX)
      .translations('es', translations.es)
      .translations('fi', translations.fi)
      .translations('fr-CA', translations.frCA)
      .translations('fr', translations.fr)
      .translations('hu', translations.hu)
      .translations('id', translations.id)
      .translations('it', translations.it)
      .translations('ja', translations.ja)
      .translations('ko', translations.ko)
      .translations('nl', translations.nl)
      .translations('no', translations.no)
      .translations('pl', translations.pl)
      .translations('pt-BR', translations.ptBR)
      .translations('ro', translations.ro)
      .translations('ru', translations.ru)
      .translations('sl', translations.sl)
      .translations('sv', translations.sv)
      .translations('th', translations.th)
      .translations('tr', translations.tr)
      .translations('uk', translations.uk)
      .translations('vi', translations.vi)
      .translations('zh-Hans', translations.zhHans)
      .translations('zh-Hant', translations.zhHant)
      .preferredLanguage('en');

    // set the default template for the alert to be our 508 compliant one.
    angular.extend($alertProvider.defaults, {
      templateUrl: 'angular-strap/alert.html'
    });

    angular.extend($modalProvider.defaults, {
      backdrop: 'static'
    });
  }]);
